// Arabic translations for the app screens (generated from the UI's English strings; hand-written Arabic).
// Keys are the exact English strings passed to t(). Entries in i18n.ts take precedence over these.
export const arApp: Record<string, string> = {
  "\". If the record still exists in the source system, it will reappear here. If it was also deleted there, nothing will come back — this doesn't recreate data out of nothing, it just re-pulls whatever the source currently has.": "\". إذا كان السجل لا يزال موجودًا في النظام المصدر فسيظهر هنا من جديد. أما إذا حُذف هناك أيضًا فلن يعود شيء — هذا الإجراء لا ينشئ بيانات من العدم، بل يعيد سحب ما يحتويه المصدر حاليًا.",
  "\". This does not affect the source system — it will reappear here on the next sync unless you also disconnect the integration.": "\". هذا لا يؤثر على النظام المصدر — وسيظهر هنا من جديد في المزامنة القادمة ما لم تفصل التكامل أيضًا.",
  "% Confidence": "% الثقة",
  "% available": "% متاح",
  "% confidence": "% ثقة",
  "% match": "% تطابق",
  "% target": "% من الهدف",
  "% to target": "% للوصول إلى الهدف",
  "% weight": "% الوزن",
  "(you)": "(أنت)",
  "AI": "الذكاء الاصطناعي",
  "AI Briefs": "ملخصات الذكاء الاصطناعي",
  "AI Briefs:": "ملخصات الذكاء الاصطناعي:",
  "AI Confidence:": "ثقة الذكاء الاصطناعي:",
  "AI Data Scope": "نطاق بيانات الذكاء الاصطناعي",
  "AI Explainability": "قابلية تفسير الذكاء الاصطناعي",
  "AI Explanation": "تفسير الذكاء الاصطناعي",
  "AI Governance": "حوكمة الذكاء الاصطناعي",
  "AI Insights": "رؤى الذكاء الاصطناعي",
  "AI Kill Switch": "مفتاح الإيقاف الطارئ للذكاء الاصطناعي",
  "AI Model Registry": "سجل نماذج الذكاء الاصطناعي",
  "AI Operating Principles": "مبادئ تشغيل الذكاء الاصطناعي",
  "AI Operating Principles:": "مبادئ تشغيل الذكاء الاصطناعي:",
  "AI Output State Management": "إدارة حالة مخرجات الذكاء الاصطناعي",
  "AI Productivity Impact": "أثر الذكاء الاصطناعي على الإنتاجية",
  "AI Reply": "رد الذكاء الاصطناعي",
  "AI Reply Generated": "تم إنشاء الرد بالذكاء الاصطناعي",
  "AI Risk Register": "سجل مخاطر الذكاء الاصطناعي",
  "AI Risks": "مخاطر الذكاء الاصطناعي",
  "AI Scope": "نطاق الذكاء الاصطناعي",
  "AI Summary": "ملخص الذكاء الاصطناعي",
  "AI access is scoped to your role permissions": "وصول الذكاء الاصطناعي محدود بصلاحيات دورك",
  "AI analysis will appear here": "سيظهر تحليل الذكاء الاصطناعي هنا",
  "AI assists preparation and analysis": "يساعد الذكاء الاصطناعي في التحضير والتحليل",
  "AI drafts slides from your project's real data. You can edit everything before exporting.": "يصيغ الذكاء الاصطناعي الشرائح من بيانات مشروعك الفعلية. يمكنك تعديل كل شيء قبل التصدير.",
  "AI explainability details are now available.": "تفاصيل قابلية تفسير الذكاء الاصطناعي متاحة الآن.",
  "AI only accesses data within your role permissions. Disabling a scope prevents AI from using that data for recommendations. Your data is never shared externally.": "لا يصل الذكاء الاصطناعي إلا إلى البيانات ضمن صلاحيات دورك. تعطيل أي نطاق يمنع الذكاء الاصطناعي من استخدام تلك البيانات في توصياته. بياناتك لا تُشارك مع أي جهة خارجية.",
  "AI recommends allocating 2 additional resources to Sprint 12 to meet the deadline.": "يوصي الذكاء الاصطناعي بتخصيص موردين إضافيين لـ Sprint 12 لتحقيق الموعد النهائي.",
  "AI summary isn't available for this file type yet.": "ملخص الذكاء الاصطناعي غير متاح لهذا النوع من الملفات بعد.",
  "AI will analyze your projects, tasks, meetings, and emails to create a comprehensive weekly status summary.": "سيحلل الذكاء الاصطناعي مشاريعك ومهامك واجتماعاتك وبريدك الإلكتروني لإنشاء ملخص حالة أسبوعي شامل.",
  "AI-Verified Insights": "رؤى موثّقة بالذكاء الاصطناعي",
  "AI-generated recommendations awaiting a human decision": "توصيات من الذكاء الاصطناعي بانتظار قرار بشري",
  "AI-generated status summary for": "ملخص الحالة المُنشأ بالذكاء الاصطناعي لـ",
  "AI-powered meeting analysis and minutes generation": "تحليل الاجتماعات وإنشاء المحاضر بالذكاء الاصطناعي",
  "AI-powered reports from your project data": "تقارير من بيانات مشاريعك بالذكاء الاصطناعي",
  "API Key": "مفتاح API",
  "Accent": "لون التمييز",
  "Accent Color": "لون التمييز",
  "Accept": "قبول",
  "Accept signal": "قبول الإشارة",
  "Access Denied": "الوصول مرفوض",
  "Access Restricted": "الوصول مقيّد",
  "Access documentation and presentation materials": "الوصول إلى الوثائق والمواد التقديمية",
  "Access expired. An admin needs to reconnect this source on the Integrations page.": "انتهت صلاحية الوصول. يحتاج المسؤول إلى إعادة ربط هذا المصدر من صفحة التكاملات.",
  "Access files from Google Drive": "الوصول إلى الملفات من Google Drive",
  "Access files from Microsoft OneDrive": "الوصول إلى الملفات من Microsoft OneDrive",
  "Across": "عبر",
  "Action Hub": "مركز الإجراءات",
  "Action Items": "بنود الإجراءات",
  "Action Types": "أنواع الإجراءات",
  "Action added": "تمت إضافة الإجراء",
  "Actions": "الإجراءات",
  "Actions Required": "الإجراءات المطلوبة",
  "Actions and unique users per day": "الإجراءات والمستخدمون الفريدون يوميًا",
  "Actions extracted from meetings and email, plus manual entries — review before they become tracked work.": "إجراءات مستخرجة من الاجتماعات والبريد، إضافة إلى الإدخالات اليدوية — راجعها قبل أن تتحول إلى عمل متابَع.",
  "Activated": "تم التفعيل",
  "Activation failed": "فشل التفعيل",
  "Active": "نشط",
  "Active Findings": "النتائج النشطة",
  "Active Projects": "المشاريع النشطة",
  "Active Signals": "الإشارات النشطة",
  "Active Users": "المستخدمون النشطون",
  "Actual": "الفعلي",
  "Add": "إضافة",
  "Add Action": "إضافة إجراء",
  "Add Bullet": "إضافة نقطة",
  "Add Connection": "إضافة اتصال",
  "Add Event": "إضافة حدث",
  "Add First Integration": "إضافة أول تكامل",
  "Add More Templates": "إضافة المزيد من القوالب",
  "Add Policy": "إضافة سياسة",
  "Add Slide": "إضافة شريحة",
  "Add Stakeholder": "إضافة صاحب مصلحة",
  "Add Strategic Pillar": "إضافة ركيزة استراتيجية",
  "Add Task": "إضافة مهمة",
  "Add Template": "إضافة قالب",
  "Add User": "إضافة مستخدم",
  "Add a": "أضف",
  "Add a starter template or generate one from a project above": "أضف قالبًا جاهزًا أو أنشئ واحدًا من مشروع أعلاه",
  "Add a user to your organization": "أضف مستخدمًا إلى مؤسستك",
  "Add folder": "إضافة مجلد",
  "Add notes about this decision...": "أضف ملاحظات عن هذا القرار...",
  "Add pillar": "إضافة ركيزة",
  "Add pre-built templates or create your own": "أضف قوالب جاهزة أو أنشئ قوالبك الخاصة",
  "Add teammates and manage their roles": "أضف زملاء الفريق وأدر أدوارهم",
  "Add text content to your knowledge base": "أضف محتوى نصيًا إلى قاعدة المعرفة",
  "Added": "تمت الإضافة",
  "Adding...": "جارٍ الإضافة...",
  "Additional context, steps to reproduce, impact…": "سياق إضافي، خطوات إعادة الإنتاج، الأثر…",
  "Admin Notes (optional)": "ملاحظات المسؤول (اختياري)",
  "Admin note:": "ملاحظة المسؤول:",
  "Aggregate Signals Only": "الإشارات المجمّعة فقط",
  "Aggregate communication intelligence from connected systems": "ذكاء مجمّع عن التواصل من الأنظمة المرتبطة",
  "Aggregate view across all programmes and projects": "عرض مجمّع لكل البرامج والمشاريع",
  "All": "الكل",
  "All (": "الكل (",
  "All AI modules are operating normally. Outputs flow through HITL review.": "جميع وحدات الذكاء الاصطناعي تعمل بشكل طبيعي. تمر المخرجات عبر المراجعة البشرية.",
  "All Categories": "كل الفئات",
  "All Projects": "كل المشاريع",
  "All Statuses": "كل الحالات",
  "All actions": "كل الإجراءات",
  "All caught up": "كل شي تمام",
  "All data shown has been reviewed and approved through the governance workflow. Reports undergo Draft → Reviewed → Approved → Published stages before appearing here.": "كل البيانات المعروضة تمت مراجعتها واعتمادها عبر مسار الحوكمة. تمر التقارير بمراحل مسودة ← تمت المراجعة ← معتمد ← منشور قبل ظهورها هنا.",
  "All documents are up to date.": "كل المستندات محدّثة.",
  "All projects": "كل المشاريع",
  "All sources": "كل المصادر",
  "All time": "كل الأوقات",
  "All tracked activities": "كل الأنشطة المتابَعة",
  "Allow users to view aggregated communication signals": "السماح للمستخدمين بعرض إشارات التواصل المجمّعة",
  "Already a member": "عضو بالفعل",
  "Also clear all synced": "احذف أيضًا كل ما تمت مزامنته من",
  "Always On": "يعمل دائمًا",
  "Amount": "المبلغ",
  "An admin can connect Google Drive or Microsoft 365 folders on the": "يمكن للمسؤول ربط مجلدات Google Drive أو Microsoft 365 في",
  "Analysis stopped unexpectedly.": "توقف التحليل بشكل غير متوقع.",
  "Analyze new files (": "تحليل الملفات الجديدة (",
  "Analyzing": "جارٍ التحليل",
  "Analyzing content...": "جارٍ تحليل المحتوى...",
  "Analyzing open risk signals and generating recommendations...": "جارٍ تحليل إشارات المخاطر المفتوحة وإنشاء التوصيات...",
  "Analyzing your week and generating digest...": "جارٍ تحليل أسبوعك وإنشاء الملخص...",
  "Applies To": "ينطبق على",
  "Approval Workflow": "سير عمل الموافقات",
  "Approve": "موافقة",
  "Approved": "تمت الموافقة",
  "Approved (": "تمت الموافقة (",
  "Approved Data Only": "البيانات المعتمدة فقط",
  "Approved Reports": "التقارير المعتمدة",
  "Ask Questions": "اطرح أسئلة",
  "Ask a question about your documents...": "اسأل عن مستنداتك...",
  "Ask questions about your uploaded documents": "اطرح أسئلة عن المستندات التي رفعتها",
  "Assign Role": "تعيين دور",
  "Assign roles to team members to control feature access": "عيّن أدوارًا لأعضاء الفريق للتحكم في الوصول إلى الميزات",
  "Assigned Projects": "المشاريع المسندة",
  "Assignee": "المسؤول",
  "Assignee:": "المسؤول:",
  "At Risk": "معرّض للخطر",
  "At least 8 characters": "8 أحرف على الأقل",
  "At risk": "معرّض للخطر",
  "Attach": "إرفاق",
  "Attendees": "الحضور",
  "Audit Log": "سجل التدقيق",
  "Auto-Generated Reports": "التقارير المُنشأة تلقائيًا",
  "Available MCP Tools": "أدوات MCP المتاحة",
  "Avatar Uploaded": "تم رفع الصورة الشخصية",
  "Average ROI": "متوسط العائد على الاستثمار",
  "Average velocity": "متوسط السرعة",
  "Avg Performance": "متوسط الأداء",
  "Avg Progress": "متوسط التقدم",
  "Avg Response Time": "متوسط زمن الاستجابة",
  "Avg Workload": "متوسط عبء العمل",
  "Awaiting a reply": "بانتظار رد",
  "Back to Integrations": "العودة إلى التكاملات",
  "Back to Presentations": "العودة إلى العروض التقديمية",
  "Bias": "التحيّز",
  "Blocked tasks": "المهام المتعطلة",
  "Blueprint file is downloading.": "جارٍ تنزيل ملف المخطط.",
  "Body Font": "خط النص",
  "Brand Colors": "ألوان الهوية",
  "Branding & Templates": "الهوية والقوالب",
  "Branding saved": "تم حفظ الهوية",
  "Brief description of the issue": "وصف مختصر للمشكلة",
  "Brief description of the risk": "وصف مختصر للخطر",
  "Brief pending": "الملخص قيد الإعداد",
  "Browse Templates": "تصفح القوالب",
  "Browse to the project folder and select it. Only the file types ticked below are ingested.": "اذهب إلى مجلد المشروع واخترْه. تُستورد فقط أنواع الملفات المحددة أدناه.",
  "Budget": "الميزانية",
  "Budget Forecast": "توقعات الميزانية",
  "Budget Spent": "الميزانية المصروفة",
  "Budget forecast saved": "تم حفظ توقعات الميزانية",
  "Budget vs Actuals": "الميزانية مقابل الفعلي",
  "Budget ·": "الميزانية ·",
  "Budget:": "الميزانية:",
  "Built-in": "مدمج",
  "Bullet point": "نقطة",
  "By day": "حسب اليوم",
  "By person": "حسب الشخص",
  "By project": "حسب المشروع",
  "By record": "حسب السجل",
  "By source": "حسب المصدر",
  "Calendar view": "عرض التقويم",
  "Cancel": "إلغاء",
  "Candidates": "المرشحون",
  "Cards": "بطاقات",
  "Categories": "الفئات",
  "Category": "الفئة",
  "Category:": "الفئة:",
  "Change Password": "تغيير كلمة المرور",
  "Channels": "القنوات",
  "Check again": "تحقق مرة ثانية",
  "Checking...": "جارٍ التحقق...",
  "Choose a role...": "اختر دورًا...",
  "Choose from pre-built email templates": "اختر من قوالب البريد الجاهزة",
  "Choose from pre-built templates": "اختر من القوالب الجاهزة",
  "Choose from starter templates": "اختر من القوالب الأولية",
  "Choose your brand color palette": "اختر لوحة ألوان هويتك",
  "Classification": "التصنيف",
  "Clear": "مسح",
  "Clear All": "مسح الكل",
  "Clear Data": "مسح البيانات",
  "Clear failed": "فشل المسح",
  "Clear filter": "مسح التصفية",
  "Clear filters": "مسح التصفيات",
  "Clear synced data": "مسح البيانات المتزامنة",
  "Clear synced data?": "مسح البيانات المتزامنة؟",
  "Cleared all synthetic signals": "تم مسح كل الإشارات التجريبية",
  "Click \"Analyze & Suggest\" to extract actionable tasks from this": "اضغط \"تحليل واقتراح\" لاستخراج المهام القابلة للتنفيذ من هذا",
  "Click the action button to advance through the workflow stages": "اضغط زر الإجراء للانتقال بين مراحل سير العمل",
  "Close": "إغلاق",
  "Closed": "مغلق",
  "Cloud Storage": "التخزين السحابي",
  "Coming up": "قريبًا",
  "Comma-separated names (optional)": "أسماء مفصولة بفواصل (اختياري)",
  "Communication (": "التواصل (",
  "Communication Plan": "خطة التواصل",
  "Communication Schedule": "جدول التواصل",
  "Communication Signals": "إشارات التواصل",
  "Communication could not be loaded. Try again shortly.": "تعذّر تحميل التواصل. حاول مرة ثانية بعد قليل.",
  "Communications analyzed": "الاتصالات التي تم تحليلها",
  "Compact Explainability": "قابلية التفسير المختصرة",
  "Company Identity": "هوية الشركة",
  "Company Logo": "شعار الشركة",
  "Company Name": "اسم الشركة",
  "Company logo": "شعار الشركة",
  "Complete product details and specifications": "تفاصيل ومواصفات المنتج الكاملة",
  "Complete technical blueprint for replication": "المخطط التقني الكامل للتكرار",
  "Completed": "مكتمل",
  "Completed (": "مكتمل (",
  "Completion": "نسبة الإنجاز",
  "Compliance Center": "مركز الامتثال",
  "Compliance Checklist": "قائمة التحقق من الامتثال",
  "Compliance checklist completion:": "اكتمال قائمة التحقق من الامتثال:",
  "Compliance report exported": "تم تصدير تقرير الامتثال",
  "Compliant": "ممتثل",
  "Configuration options coming soon...": "خيارات الإعداد قريبًا...",
  "Configure AI behavior and approval requirements": "اضبط سلوك الذكاء الاصطناعي ومتطلبات الموافقة",
  "Configure SAML 2.0, OIDC, or Microsoft Entra ID for enterprise SSO. Contact your identity provider for these values.": "اضبط SAML 2.0 أو OIDC أو Microsoft Entra ID لتسجيل الدخول الموحد للمؤسسات. تواصل مع مزود الهوية للحصول على هذه القيم.",
  "Configure how risk signals are generated and displayed": "اضبط طريقة إنشاء إشارات المخاطر وعرضها",
  "Configure the transactional email provider used for digest, HITL approval, and signal alert emails.": "اضبط مزود البريد الإلكتروني المستخدم لرسائل الملخص والموافقات البشرية وتنبيهات الإشارات.",
  "Configure where data is stored and processed to support your data-protection and residency requirements": "اضبط مكان تخزين البيانات ومعالجتها بما يدعم متطلبات حماية البيانات وإقامتها",
  "Configure your Model Context Protocol server settings": "اضبط إعدادات خادم Model Context Protocol",
  "Confirm": "تأكيد",
  "Confirm New Password": "تأكيد كلمة المرور الجديدة",
  "Confirm Reject": "تأكيد الرفض",
  "Connect": "ربط",
  "Connect Microsoft 365 above first.": "اربط Microsoft 365 أعلاه أولًا.",
  "Connect OneDrive": "ربط OneDrive",
  "Connect OneDrive from Integrations before syncing documents.": "اربط OneDrive من صفحة التكاملات قبل مزامنة المستندات.",
  "Connect an integration (Jira, Azure DevOps, etc.) to see them here.": "اربط تكاملًا (Jira أو Azure DevOps وغيرها) لتظهر هنا.",
  "Connect cloud storage services to access your files": "اربط خدمات التخزين السحابي للوصول إلى ملفاتك",
  "Connect email accounts to sync with Masira": "اربط حسابات البريد الإلكتروني للمزامنة مع Masira",
  "Connect external data sources and import files": "اربط مصادر البيانات الخارجية واستورد الملفات",
  "Connect to Jira, Azure DevOps, ServiceNow, or Microsoft 365 to sync project data": "اربط Jira أو Azure DevOps أو ServiceNow أو Microsoft 365 لمزامنة بيانات المشاريع",
  "Connect to your MCP server to see available tools and capabilities.": "اربط خادم MCP لعرض الأدوات والإمكانات المتاحة.",
  "Connect your Gmail account": "اربط حساب Gmail",
  "Connect your Outlook account": "اربط حساب Outlook",
  "Connect your tools": "اربط أدواتك",
  "Connection Name": "اسم الاتصال",
  "Connection configured successfully": "تم إعداد الاتصال بنجاح",
  "Connection settings saved": "تم حفظ إعدادات الاتصال",
  "Connections": "الاتصالات",
  "Consent Log": "سجل الموافقات",
  "Consent recorded": "تم تسجيل الموافقة",
  "Consistent formatting": "تنسيق متّسق",
  "Content": "المحتوى",
  "Contextual explanations for content visibility": "شروحات سياقية لظهور المحتوى",
  "Contributing Factors": "العوامل المساهمة",
  "Control how data is used and protected": "تحكّم في كيفية استخدام البيانات وحمايتها",
  "Control the communication intelligence feature": "تحكّم في ميزة ذكاء التواصل",
  "Copied": "تم النسخ",
  "Copied to clipboard": "تم النسخ إلى الحافظة",
  "Copy": "نسخ",
  "Copy Failed": "فشل النسخ",
  "Correct": "تصحيح",
  "Corrected (": "تم التصحيح (",
  "Corrected description": "الوصف المصحَّح",
  "Corrected payload (JSON)": "الحمولة المصحَّحة (JSON)",
  "Corrected payload must be valid JSON": "يجب أن تكون الحمولة المصحَّحة بصيغة JSON صالحة",
  "Corrected title": "العنوان المصحَّح",
  "Correction Freq. (30d)": "تكرار التصحيح (30 يومًا)",
  "Cost": "التكلفة",
  "Could not add mapping": "تعذّرت إضافة الربط",
  "Could not create document": "تعذّر إنشاء المستند",
  "Could not delete template": "تعذّر حذف القالب",
  "Could not download document": "تعذّر تنزيل المستند",
  "Could not download the blueprint file.": "تعذّر تنزيل ملف المخطط.",
  "Could not generate AI explanation.": "تعذّر إنشاء تفسير الذكاء الاصطناعي.",
  "Could not generate summary": "تعذّر إنشاء الملخص",
  "Could not load custom templates": "تعذّر تحميل القوالب المخصصة",
  "Could not open document": "تعذّر فتح المستند",
  "Could not remove mapping": "تعذّرت إزالة الربط",
  "Could not save": "تعذّر الحفظ",
  "Could not save template": "تعذّر حفظ القالب",
  "Could not save the new status. Please try again.": "تعذّر حفظ الحالة الجديدة. حاول مرة ثانية.",
  "Could not start Microsoft 365 connection": "تعذّر بدء الربط مع Microsoft 365",
  "Could not start sync": "تعذّر بدء المزامنة",
  "Could not update star": "تعذّر تحديث النجمة",
  "Create Decision": "إنشاء قرار",
  "Create Event": "إنشاء حدث",
  "Create New Event": "إنشاء حدث جديد",
  "Create Policy": "إنشاء سياسة",
  "Create and manage document templates": "أنشئ قوالب المستندات وأدرها",
  "Create as new project": "إنشاء كمشروع جديد",
  "Create branded email templates for your communications": "أنشئ قوالب بريد إلكتروني بهوية شركتك لمراسلاتك",
  "Created": "تم الإنشاء",
  "Created as": "أُنشئ باسم",
  "Critical": "حرج",
  "Critical Risk": "خطر حرج",
  "Currency changes how amounts are displayed. Stored values are not converted, so switching currency relabels the same numbers rather than applying an exchange rate. Most screens are translated; some pages (reports, exports, docs) and AI-generated text outside chat stay in English.": "تغيير العملة يغيّر طريقة عرض المبالغ فقط. القيم المخزّنة لا تُحوَّل، فتبديل العملة يعيد تسمية الأرقام نفسها ولا يطبّق سعر صرف. معظم الشاشات مترجمة؛ وبعض الصفحات (التقارير والتصدير والوثائق) ونصوص الذكاء الاصطناعي خارج المحادثة تبقى بالإنجليزية.",
  "Current Breaches": "المخالفات الحالية",
  "Current Load": "الحِمل الحالي",
  "Current Role": "الدور الحالي",
  "Customize your company branding and manage templates": "خصّص هوية شركتك وأدر القوالب",
  "Daily Activity (Last 7 Days)": "النشاط اليومي (آخر 7 أيام)",
  "Dashboard refreshed": "تم تحديث لوحة المعلومات",
  "Data Governance": "حوكمة البيانات",
  "Data Integrations": "تكاملات البيانات",
  "Data Residency": "إقامة البيانات",
  "Data Residency Configuration": "إعداد إقامة البيانات",
  "Data Sources": "مصادر البيانات",
  "Data Subject": "صاحب البيانات",
  "Data Subject Email *": "بريد صاحب البيانات *",
  "Data Usage Governance": "حوكمة استخدام البيانات",
  "Data sources": "مصادر البيانات",
  "Date": "التاريخ",
  "Date range": "النطاق الزمني",
  "Decided": "تم اتخاذ القرار",
  "Decided (": "تم اتخاذ القرار (",
  "Decision": "القرار",
  "Decision Brief": "ملخص القرار",
  "Decision Created": "تم إنشاء القرار",
  "Decision Details": "تفاصيل القرار",
  "Decision ID": "معرّف القرار",
  "Decision Log": "سجل القرارات",
  "Decision details...": "تفاصيل القرار...",
  "Decision events, newest first": "أحداث القرارات، الأحدث أولًا",
  "Decision title": "عنوان القرار",
  "Decisions could not be loaded. Try again shortly.": "تعذّر تحميل القرارات. حاول مرة ثانية بعد قليل.",
  "Deck Type": "نوع العرض",
  "Declined": "مرفوض",
  "Defer": "تأجيل",
  "Delayed": "متأخر",
  "Delete": "حذف",
  "Delete \"": "حذف \"",
  "Delete failed": "فشل الحذف",
  "Delete synced record": "حذف السجل المتزامن",
  "Delete this synced record?": "حذف هذا السجل المتزامن؟",
  "Delivery data could not be loaded. Try again shortly.": "تعذّر تحميل بيانات التنفيذ. حاول مرة ثانية بعد قليل.",
  "Department Distribution": "توزيع الأقسام",
  "Description": "الوصف",
  "Destination (AI suggested:": "الوجهة (اقتراح الذكاء الاصطناعي:",
  "Details": "التفاصيل",
  "Detection, analysis, review and decision in one feed": "الرصد والتحليل والمراجعة والقرار في موجز واحد",
  "Deterministic + Evidence-based": "حتمي + قائم على الأدلة",
  "Digest downloaded as PDF": "تم تنزيل الملخص بصيغة PDF",
  "Disable predictive analytics on individual performance": "تعطيل التحليلات التنبؤية لأداء الأفراد",
  "Disabled": "معطّل",
  "Discard": "تجاهل",
  "Disconnected": "غير متصل",
  "Dismiss": "إغلاق",
  "Display Name": "الاسم المعروض",
  "Distribution of activity types": "توزيع أنواع النشاط",
  "Document Templates": "قوالب المستندات",
  "Document Title": "عنوان المستند",
  "Document URL": "رابط المستند",
  "Document created": "تم إنشاء المستند",
  "Document deleted": "تم حذف المستند",
  "Document uploaded": "تم رفع المستند",
  "Documents (": "المستندات (",
  "Download": "تنزيل",
  "Download Failed": "فشل التنزيل",
  "Download Started": "بدأ التنزيل",
  "Downloaded": "تم التنزيل",
  "Draft": "مسودة",
  "Draft → Reviewed → Approved pipeline for every AI output": "مسار مسودة ← تمت المراجعة ← معتمد لكل مخرجات الذكاء الاصطناعي",
  "Due": "الاستحقاق",
  "Due Date": "تاريخ الاستحقاق",
  "Due date": "تاريخ الاستحقاق",
  "Due:": "الاستحقاق:",
  "Edit": "تعديل",
  "Edit Details": "تعديل التفاصيل",
  "Edit prompt —": "تعديل الموجّه —",
  "Email": "البريد الإلكتروني",
  "Email *": "البريد الإلكتروني *",
  "Email Accounts": "حسابات البريد الإلكتروني",
  "Email Body": "نص البريد",
  "Email Notifications": "إشعارات البريد الإلكتروني",
  "Email Preview": "معاينة البريد",
  "Email Signals": "إشارات البريد الإلكتروني",
  "Email Templates": "قوالب البريد الإلكتروني",
  "Email and purpose required": "البريد الإلكتروني والغرض مطلوبان",
  "Email cannot be changed": "لا يمكن تغيير البريد الإلكتروني",
  "Email signal mapping is only available for synced projects.": "ربط إشارات البريد متاح للمشاريع المتزامنة فقط.",
  "Email template copied to clipboard.": "تم نسخ قالب البريد إلى الحافظة.",
  "Email volume:": "حجم البريد:",
  "Emails Analyzed": "الرسائل التي تم تحليلها",
  "Enable Smart Inbox": "تفعيل الصندوق الذكي",
  "Enable or disable features for each role. Admin role always has full access.": "فعّل الميزات أو عطّلها لكل دور. دور المسؤول يملك دائمًا وصولًا كاملًا.",
  "End date": "تاريخ الانتهاء",
  "End:": "الانتهاء:",
  "Enforced": "مُطبَّق",
  "Enter company name": "أدخل اسم الشركة",
  "Enter company tagline": "أدخل شعار الشركة النصي",
  "Enter email content...": "أدخل محتوى البريد...",
  "Enter email subject": "أدخل موضوع البريد",
  "Enter template content... Use {{variable}} for placeholders": "أدخل محتوى القالب... استخدم {{variable}} للعناصر البديلة",
  "Enter template name": "أدخل اسم القالب",
  "Enter your display name": "أدخل اسمك المعروض",
  "Error": "خطأ",
  "Error:": "خطأ:",
  "Escalate": "تصعيد",
  "Escalated (": "تم التصعيد (",
  "Escalated email": "بريد مُصعَّد",
  "Escalations": "التصعيدات",
  "Event": "الحدث",
  "Event Created": "تم إنشاء الحدث",
  "Event details...": "تفاصيل الحدث...",
  "Event title": "عنوان الحدث",
  "Everyone": "الجميع",
  "Evidence-Based Only": "القائم على الأدلة فقط",
  "Executive Overview": "نظرة تنفيذية عامة",
  "Executive Summary": "الملخص التنفيذي",
  "Expandable explanation for inline use": "شرح قابل للتوسيع للاستخدام ضمن السطر",
  "Expires": "ينتهي",
  "Expiry Date (optional)": "تاريخ الانتهاء (اختياري)",
  "Explainability": "قابلية التفسير",
  "Explanation Failed": "فشل التفسير",
  "Explanation Generated": "تم إنشاء التفسير",
  "Export CSV": "تصدير CSV",
  "Export PDF": "تصدير PDF",
  "Export PPTX": "تصدير PPTX",
  "Export Report": "تصدير التقرير",
  "Export failed": "فشل التصدير",
  "Export to PDF": "تصدير إلى PDF",
  "External": "خارجي",
  "Extracted Actions": "الإجراءات المستخرجة",
  "Factors": "العوامل",
  "Facts": "الحقائق",
  "Failed to add task to Action Hub": "تعذّرت إضافة المهمة إلى مركز الإجراءات",
  "Failed to add template": "تعذّرت إضافة القالب",
  "Failed to analyze meeting. Please try again.": "تعذّر تحليل الاجتماع. حاول مرة ثانية.",
  "Failed to approve request": "تعذّرت الموافقة على الطلب",
  "Failed to copy report content.": "تعذّر نسخ محتوى التقرير.",
  "Failed to create decision": "تعذّر إنشاء القرار",
  "Failed to generate digest": "تعذّر إنشاء الملخص",
  "Failed to generate mitigation suggestions. Please try again.": "تعذّر إنشاء اقتراحات المعالجة. حاول مرة ثانية.",
  "Failed to generate suggestions": "تعذّر إنشاء الاقتراحات",
  "Failed to load decisions": "تعذّر تحميل القرارات",
  "Failed to load feature permissions": "تعذّر تحميل صلاحيات الميزات",
  "Failed to load role requests": "تعذّر تحميل طلبات الأدوار",
  "Failed to load users": "تعذّر تحميل المستخدمين",
  "Failed to read transcript file": "تعذّرت قراءة ملف النص المفرّغ",
  "Failed to reject request": "تعذّر رفض الطلب",
  "Failed to save IP allowlist.": "تعذّر حفظ قائمة العناوين المسموح بها.",
  "Failed to save SSO configuration.": "تعذّر حفظ إعدادات SSO.",
  "Failed to save notification settings.": "تعذّر حفظ إعدادات الإشعارات.",
  "Failed to save permissions": "تعذّر حفظ الصلاحيات",
  "Failed to send alerts": "تعذّر إرسال التنبيهات",
  "Failed to submit role request": "تعذّر إرسال طلب الدور",
  "Failed to update setting. Please try again.": "تعذّر تحديث الإعداد. حاول مرة ثانية.",
  "Failed to update status": "تعذّر تحديث الحالة",
  "Failed to update user role": "تعذّر تحديث دور المستخدم",
  "Feature": "الميزة",
  "Feature Toggles": "مفاتيح الميزات",
  "Feature Usage": "استخدام الميزات",
  "Feature disabled by Tenant Administrator": "الميزة معطّلة من مسؤول المؤسسة",
  "Feature interactions": "تفاعلات الميزات",
  "Feature navigation breakdown": "تفصيل التنقل في الميزات",
  "Feature permissions saved successfully": "تم حفظ صلاحيات الميزات بنجاح",
  "Features": "الميزات",
  "File": "ملف",
  "File Imports": "استيراد الملفات",
  "File parsed": "تمت قراءة الملف",
  "File parsed but import had issues": "تمت قراءة الملف لكن حدثت مشاكل أثناء الاستيراد",
  "File too large": "الملف كبير جدًا",
  "File types": "أنواع الملفات",
  "Files synced, but could not check for documents to analyze.": "تمت مزامنة الملفات، لكن تعذّر التحقق من وجود مستندات للتحليل.",
  "Filter by action": "تصفية حسب الإجراء",
  "Filter by category": "تصفية حسب الفئة",
  "Filter by person": "تصفية حسب الشخص",
  "Filter by status": "تصفية حسب الحالة",
  "Filter candidates by source": "تصفية المرشحين حسب المصدر",
  "Filter files by source": "تصفية الملفات حسب المصدر",
  "Filter files by status": "تصفية الملفات حسب الحالة",
  "Flagged communications": "الاتصالات المُعلَّمة",
  "Flagged communications, across all projects": "الاتصالات المُعلَّمة في كل المشاريع",
  "Folder added": "تمت إضافة المجلد",
  "Folder removed": "تمت إزالة المجلد",
  "Folder:": "المجلد:",
  "Folders": "المجلدات",
  "Follow-ups from meetings": "متابعات الاجتماعات",
  "Forecast": "التوقعات",
  "Framework": "الإطار",
  "Frequency": "التكرار",
  "From Email": "البريد المُرسِل",
  "From Name": "اسم المُرسِل",
  "Full Access": "وصول كامل",
  "GDPR · Data · Portfolio · AI governance tracking": "GDPR · البيانات · المحفظة · متابعة حوكمة الذكاء الاصطناعي",
  "Generate": "إنشاء",
  "Generate Presentation": "إنشاء عرض تقديمي",
  "Generate Recommendations": "إنشاء التوصيات",
  "Generate Report": "إنشاء تقرير",
  "Generate Summary": "إنشاء ملخص",
  "Generate Weekly Digest": "إنشاء الملخص الأسبوعي",
  "Generate Your Weekly Digest": "أنشئ ملخصك الأسبوعي",
  "Generate a branded, meeting-ready deck from real project data, or start from a template": "أنشئ عرضًا بهوية شركتك جاهزًا للاجتماعات من بيانات المشروع الفعلية، أو ابدأ من قالب",
  "Generate and monitor realistic enterprise signals for testing": "أنشئ إشارات مؤسسية واقعية وراقبها للاختبار",
  "Generate concrete mitigation suggestions grounded in this project's currently open risk signals.": "أنشئ اقتراحات معالجة محددة مبنية على إشارات المخاطر المفتوحة حاليًا في هذا المشروع.",
  "Generate from Project": "إنشاء من مشروع",
  "Generate your first report to see it here": "أنشئ أول تقرير لك ليظهر هنا",
  "Generated": "تم الإنشاء",
  "Generated:": "تم الإنشاء:",
  "Generating...": "جارٍ الإنشاء...",
  "Generation Failed": "فشل الإنشاء",
  "Generation failed": "فشل الإنشاء",
  "Get Started": "ابدأ الآن",
  "Get Started with Email Templates": "ابدأ مع قوالب البريد الإلكتروني",
  "Get Started with Templates": "ابدأ مع القوالب",
  "Gmail": "Gmail",
  "Go to the Upload tab to add your first document.": "اذهب إلى تبويب الرفع لإضافة أول مستند.",
  "Go to…": "الانتقال إلى…",
  "Good": "جيد",
  "Google Drive": "Google Drive",
  "Governance": "الحوكمة",
  "Governance (": "الحوكمة (",
  "Governance Policies": "سياسات الحوكمة",
  "Governance Score": "درجة الحوكمة",
  "Governance Score Trend": "اتجاه درجة الحوكمة",
  "Governance Timeline": "الجدول الزمني للحوكمة",
  "Governance score, history, and the full evidence timeline.": "درجة الحوكمة وسجلها والجدول الزمني الكامل للأدلة.",
  "Governed Feature:": "الميزة الخاضعة للحوكمة:",
  "Granted": "ممنوح",
  "Groq, OpenAI…": "Groq، OpenAI…",
  "Grounded in": "مبني على",
  "Group": "المجموعة",
  "Group by": "التجميع حسب",
  "Group by project": "التجميع حسب المشروع",
  "HITL Review Rate": "معدل المراجعة البشرية",
  "HITL Review Workbench": "مساحة المراجعة البشرية",
  "HITL review rate vs correction frequency (30 days)": "معدل المراجعة البشرية مقابل تكرار التصحيح (30 يومًا)",
  "Hallucination": "الهلوسة",
  "Heading Font": "خط العناوين",
  "Health": "الصحة",
  "Health, completion, and blockers for every tracked release.": "الصحة والإنجاز والعوائق لكل إصدار متابَع.",
  "High": "عالٍ",
  "High severity": "خطورة عالية",
  "History (": "السجل (",
  "How AI Reports Work": "كيف تعمل تقارير الذكاء الاصطناعي",
  "How should they get access?": "كيف تبغى يحصل على الوصول؟",
  "Human Approval Required": "موافقة بشرية مطلوبة",
  "Human-in-the-loop oversight: approval workflow · review workbench · policy rules · kill switch": "إشراف بشري: سير الموافقات · مساحة المراجعة · قواعد السياسات · مفتاح الإيقاف الطارئ",
  "Humans approve, decide, and remain accountable": "البشر يوافقون ويقررون ويبقون مسؤولين",
  "IP Allowlist": "قائمة العناوين المسموح بها",
  "IP Allowlist Saved": "تم حفظ قائمة العناوين المسموح بها",
  "ISO 27001": "ISO 27001",
  "Identity Provider": "مزود الهوية",
  "Immediate halt of all AI-generated outputs across the platform": "إيقاف فوري لكل مخرجات الذكاء الاصطناعي على المنصة",
  "Impact": "الأثر",
  "Impact is the worst open signal severity on the project (low is Minor, medium Moderate, high Major, critical Catastrophic). Likelihood is the number of open signals backing it (1 is Very Low up to 5 or more Very High).": "الأثر هو أعلى خطورة بين الإشارات المفتوحة على المشروع (منخفض = طفيف، متوسط = معتدل، عالٍ = كبير، حرج = كارثي). أما الاحتمال فهو عدد الإشارات المفتوحة الداعمة له (1 = منخفض جدًا حتى 5 فأكثر = مرتفع جدًا).",
  "Import complete": "اكتمل الاستيراد",
  "Import warning": "تنبيه الاستيراد",
  "Importing data to dashboard...": "جارٍ استيراد البيانات إلى لوحة المعلومات...",
  "In Context": "ضمن السياق",
  "In Progress": "قيد التنفيذ",
  "Include subfolders": "تضمين المجلدات الفرعية",
  "Increase": "زيادة",
  "Indicator Types": "أنواع المؤشرات",
  "Inference": "الاستدلال",
  "Influence Matrix": "مصفوفة التأثير",
  "Ingested files (": "الملفات المستوردة (",
  "Ingested files from this provider were deleted.": "تم حذف الملفات المستوردة من هذا المزود.",
  "Insufficient evidence to determine the cause.": "الأدلة غير كافية لتحديد السبب.",
  "Insufficient history yet — the trend chart needs at least two weeks of detected signals for this project.": "السجل التاريخي غير كافٍ بعد — يحتاج مخطط الاتجاه إلى إشارات مكتشفة لأسبوعين على الأقل لهذا المشروع.",
  "Integration Type": "نوع التكامل",
  "Integration added": "تمت إضافة التكامل",
  "Integration removed": "تمت إزالة التكامل",
  "Integration updated": "تم تحديث التكامل",
  "Integrations page": "صفحة التكاملات",
  "Interactive Workflow": "سير عمل تفاعلي",
  "Interest:": "الاهتمام:",
  "Internal": "داخلي",
  "Investigating": "قيد التحقيق",
  "Investment": "الاستثمار",
  "Investment vs Returns analysis": "تحليل الاستثمار مقابل العوائد",
  "Invite by email, or set a temporary password to create the account directly.": "ادعُه عبر البريد الإلكتروني، أو عيّن كلمة مرور مؤقتة لإنشاء الحساب مباشرة.",
  "Issue": "المشكلة",
  "Issue Register": "سجل المشكلات",
  "Issues": "المشكلات",
  "Its files and search data were deleted.": "تم حذف ملفاته وبيانات البحث الخاصة به.",
  "JPG, PNG or GIF. Max 2MB.": "JPG أو PNG أو GIF. الحد الأقصى 2 ميجابايت.",
  "Jira, Microsoft 365, Azure DevOps and more. Masira reads, you stay in control.": "Jira وMicrosoft 365 وAzure DevOps وغيرها. Masira تقرأ، وأنت تبقى المتحكم.",
  "Join": "انضمام",
  "Joined": "تم الانضمام",
  "Key Decisions": "القرارات الرئيسية",
  "Language, text direction and currency for everyone in your organisation.": "اللغة واتجاه النص والعملة لكل من في مؤسستك.",
  "Large": "كبير",
  "Last 24 hours": "آخر 24 ساعة",
  "Last 30 days": "آخر 30 يومًا",
  "Last 7 days": "آخر 7 أيام",
  "Last Detected": "آخر اكتشاف",
  "Last contact:": "آخر تواصل:",
  "Last synced": "آخر مزامنة",
  "Last synced:": "آخر مزامنة:",
  "Leave blank to keep the current value.": "اتركه فارغًا للإبقاء على القيمة الحالية.",
  "Likelihood": "الاحتمال",
  "Limited Access": "وصول محدود",
  "Linear Issues": "مشكلات Linear",
  "Linked project": "المشروع المرتبط",
  "Linked project id (optional)": "معرّف المشروع المرتبط (اختياري)",
  "Live Data": "بيانات مباشرة",
  "Live Team Activity": "نشاط الفريق المباشر",
  "Load from a .md or .txt file": "تحميل من ملف .md أو .txt",
  "Loading data sources…": "جارٍ تحميل مصادر البيانات…",
  "Loading deployment facts…": "جارٍ تحميل حقائق النشر…",
  "Loading integrations...": "جارٍ تحميل التكاملات...",
  "Loading integrations…": "جارٍ تحميل التكاملات…",
  "Loading...": "جارٍ التحميل...",
  "Loading…": "جارٍ التحميل…",
  "Log AI Risk Entry": "تسجيل إدخال مخاطر الذكاء الاصطناعي",
  "Log Consent": "تسجيل موافقة",
  "Log Consent Record": "تسجيل سجل موافقة",
  "Log New Decision": "تسجيل قرار جديد",
  "Log Risk": "تسجيل خطر",
  "Log bias, drift, hallucination, and other AI-specific incidents": "سجّل التحيّز والانحراف والهلوسة وغيرها من حوادث الذكاء الاصطناعي",
  "Logged": "تم التسجيل",
  "Logo": "الشعار",
  "Logo uploaded": "تم رفع الشعار",
  "Low": "منخفض",
  "MCP Server Configuration": "إعداد خادم MCP",
  "MCP Server URL": "رابط خادم MCP",
  "MFA is now required. Users who haven't enrolled will be prompted on next sign-in.": "المصادقة متعددة العوامل أصبحت مطلوبة. سيُطلب من المستخدمين غير المسجّلين التسجيل عند تسجيل الدخول القادم.",
  "Manage Users": "إدارة المستخدمين",
  "Manage and track all active projects": "أدر كل المشاريع النشطة وتابعها",
  "Manage feature toggles, governance controls, and AI scope": "أدر مفاتيح الميزات وضوابط الحوكمة ونطاق الذكاء الاصطناعي",
  "Manage meetings, tasks, and milestones": "أدر الاجتماعات والمهام والمراحل",
  "Manage on Integrations": "الإدارة من صفحة التكاملات",
  "Manage stakeholders by their influence on projects": "أدر أصحاب المصلحة حسب تأثيرهم على المشاريع",
  "Mark all read": "تعليم الكل كمقروء",
  "Mark as": "تعليم كـ",
  "Mark related actions complete on send": "تعليم الإجراءات المرتبطة كمكتملة عند الإرسال",
  "Marker aliases": "بدائل العلامات",
  "Masira": "Masira",
  "Masira AI could not answer": "تعذّر على Masira AI الإجابة",
  "Masira AI could not answer. If this keeps happening, ask an administrator to check that an AI provider is configured under Admin → AI Controls.": "تعذّر على Masira AI الإجابة. إذا استمر هذا، اطلب من المسؤول التأكد من إعداد مزود ذكاء اصطناعي ضمن الإدارة ← ضوابط الذكاء الاصطناعي.",
  "Masira Recommendation": "توصية Masira",
  "Masira will stop reading “": "ستتوقف Masira عن قراءة «",
  "Match confirmed": "تم تأكيد التطابق",
  "Match dismissed": "تم تجاهل التطابق",
  "Material risks derived from synced Jira signals": "مخاطر جوهرية مستخرجة من إشارات Jira المتزامنة",
  "Max Hours to Review": "أقصى عدد ساعات للمراجعة",
  "Max hours must be a positive number": "يجب أن يكون الحد الأقصى للساعات رقمًا موجبًا",
  "Medium": "متوسط",
  "Meeting": "الاجتماع",
  "Meeting Hub": "مركز الاجتماعات",
  "Meeting title": "عنوان الاجتماع",
  "Meetings Held": "الاجتماعات المنعقدة",
  "Meetings Summarized": "الاجتماعات الملخّصة",
  "Members": "الأعضاء",
  "Message Masira": "راسل Masira",
  "Message Type": "نوع الرسالة",
  "Message Types": "أنواع الرسائل",
  "Microsoft 365": "Microsoft 365",
  "Microsoft Entra ID (Azure AD)": "Microsoft Entra ID (Azure AD)",
  "Microsoft access needs to be re-approved: use Reconnect in the Microsoft 365 card above.": "يجب إعادة الموافقة على وصول Microsoft: استخدم «إعادة الاتصال» في بطاقة Microsoft 365 أعلاه.",
  "Milestone": "المرحلة",
  "Milestones (": "المراحل (",
  "Missing fields": "حقول ناقصة",
  "Mitigated": "تمت المعالجة",
  "Mitigation Plan": "خطة المعالجة",
  "Mitigation:": "المعالجة:",
  "Model": "النموذج",
  "Model Drift": "انحراف النموذج",
  "Model Name *": "اسم النموذج *",
  "Model Registry": "سجل النماذج",
  "Model name required": "اسم النموذج مطلوب",
  "Model registered": "تم تسجيل النموذج",
  "Modified": "تم التعديل",
  "Modify": "تعديل",
  "Monitor": "مراقبة",
  "Monitor team performance, workload, and capacity": "راقب أداء الفريق وعبء العمل والطاقة الاستيعابية",
  "Monitoring required": "المراقبة مطلوبة",
  "Month": "الشهر",
  "Monthly Productivity Trend": "اتجاه الإنتاجية الشهري",
  "More Evidence (": "مزيد من الأدلة (",
  "Most Used Features": "الميزات الأكثر استخدامًا",
  "Most visited pages": "الصفحات الأكثر زيارة",
  "Multi-Factor Authentication": "المصادقة متعددة العوامل",
  "Name": "الاسم",
  "Needs a reply": "يحتاج رد",
  "New Decision": "قرار جديد",
  "New Governance Policy": "سياسة حوكمة جديدة",
  "New Issue": "مشكلة جديدة",
  "New Password": "كلمة المرور الجديدة",
  "New Policy": "سياسة جديدة",
  "New Template": "قالب جديد",
  "New decision has been logged.": "تم تسجيل القرار الجديد.",
  "New passwords do not match.": "كلمتا المرور الجديدتان غير متطابقتين.",
  "New risks raised versus risks mitigated, per month.": "المخاطر الجديدة مقابل المخاطر التي تمت معالجتها، شهريًا.",
  "Newest first": "الأحدث أولًا",
  "Next": "التالي",
  "Next Scheduled": "الموعد القادم",
  "Next Week Priorities": "أولويات الأسبوع القادم",
  "Next:": "التالي:",
  "No": "لا",
  "No AI insights yet. Insights appear once AI activity has been recorded.": "لا توجد رؤى بالذكاء الاصطناعي بعد. تظهر الرؤى بعد تسجيل نشاط للذكاء الاصطناعي.",
  "No AI outputs in this state.": "لا توجد مخرجات ذكاء اصطناعي في هذه الحالة.",
  "No AI risk entries yet": "لا توجد إدخالات مخاطر للذكاء الاصطناعي بعد",
  "No Audit Logs Yet": "لا توجد سجلات تدقيق بعد",
  "No Decisions Found": "لا توجد قرارات",
  "No People Analytics": "لا تحليلات للأفراد",
  "No Reports Yet": "لا توجد تقارير بعد",
  "No action items in this state.": "لا توجد بنود إجراءات في هذه الحالة.",
  "No actionable tasks found in content": "لم يتم العثور على مهام قابلة للتنفيذ في المحتوى",
  "No active signals": "لا توجد إشارات نشطة",
  "No activity recorded yet today.": "لا يوجد نشاط مسجّل اليوم بعد.",
  "No audit logs available": "لا توجد سجلات تدقيق",
  "No autonomous decision-making": "لا قرارات ذاتية مستقلة",
  "No breaches — everything is within policy.": "لا توجد مخالفات — كل شي ضمن السياسة.",
  "No budget forecast recorded yet.": "لا توجد توقعات ميزانية مسجّلة بعد.",
  "No completed tasks synced yet.": "لا توجد مهام مكتملة متزامنة بعد.",
  "No connector observes these two factors — enter a 0-100 rating directly, or leave blank to mark \"Not assessed\".": "لا يوجد موصّل يرصد هذين العاملين — أدخل تقييمًا من 0 إلى 100 مباشرة، أو اتركه فارغًا ليُعلَّم «غير مُقيَّم».",
  "No consent records yet": "لا توجد سجلات موافقات بعد",
  "No critical risks, pending decisions or overdue work": "لا مخاطر حرجة ولا قرارات معلّقة ولا أعمال متأخرة",
  "No data sources connected.": "لا توجد مصادر بيانات مرتبطة.",
  "No document candidates yet.": "لا يوجد مرشحون للمستندات بعد.",
  "No documents uploaded yet.": "لم يُرفع أي مستند بعد.",
  "No documents yet. Upload one to get started.": "لا توجد مستندات بعد. ارفع مستندًا للبدء.",
  "No events match these filters.": "لا توجد أحداث تطابق هذه التصفيات.",
  "No files imported yet. Upload a file to get started.": "لم تُستورد ملفات بعد. ارفع ملفًا للبدء.",
  "No folders here.": "لا توجد مجلدات هنا.",
  "No folders selected yet.": "لم تُحدَّد مجلدات بعد.",
  "No governance events recorded yet.": "لا توجد أحداث حوكمة مسجّلة بعد.",
  "No grouping": "بدون تجميع",
  "No integrations configured": "لا توجد تكاملات مُعدّة",
  "No integrations configured yet. Connect Microsoft 365, Jira, or other sources from the Integrations page.": "لا توجد تكاملات مُعدّة بعد. اربط Microsoft 365 أو Jira أو مصادر أخرى من صفحة التكاملات.",
  "No issues found": "لم يتم العثور على مشكلات",
  "No messages or meetings in the last": "لا رسائل ولا اجتماعات خلال آخر",
  "No messages yet. Ask a question to get started!": "لا توجد رسائل بعد. اطرح سؤالًا للبدء!",
  "No mitigation suggestions available": "لا توجد اقتراحات معالجة متاحة",
  "No models registered yet.": "لا توجد نماذج مسجّلة بعد.",
  "No name set": "لم يُحدَّد اسم",
  "No open action items.": "لا توجد بنود إجراءات مفتوحة.",
  "No open decisions — nothing currently requires action.": "لا قرارات مفتوحة — لا شي يحتاج إجراء حاليًا.",
  "No open findings for this project": "لا توجد نتائج مفتوحة لهذا المشروع",
  "No open findings for this project.": "لا توجد نتائج مفتوحة لهذا المشروع.",
  "No open risks.": "لا توجد مخاطر مفتوحة.",
  "No policies defined yet.": "لم تُحدَّد سياسات بعد.",
  "No policies yet": "لا توجد سياسات بعد",
  "No project ROI recorded yet.": "لم يُسجَّل العائد على الاستثمار للمشروع بعد.",
  "No projects synced yet": "لا توجد مشاريع متزامنة بعد",
  "No projects synced yet.": "لا توجد مشاريع متزامنة بعد.",
  "No projects synced yet. Connect an integration first.": "لا توجد مشاريع متزامنة بعد. اربط تكاملًا أولًا.",
  "No projects synced yet. Connect an integration to see them here.": "لا توجد مشاريع متزامنة بعد. اربط تكاملًا لتظهر هنا.",
  "No projects yet. Connect Jira, Azure DevOps or import a project file and delivery health will appear here.": "لا توجد مشاريع بعد. اربط Jira أو Azure DevOps أو استورد ملف مشروع وستظهر صحة التنفيذ هنا.",
  "No projects yet. Projects synced from integrations will appear here.": "لا توجد مشاريع بعد. ستظهر هنا المشاريع المتزامنة من التكاملات.",
  "No prompt templates found.": "لم يتم العثور على قوالب موجّهات.",
  "No quarterly performance recorded yet.": "لم يُسجَّل الأداء الربعي بعد.",
  "No recent activity": "لا يوجد نشاط حديث",
  "No releases synced yet — connect Jira and sync issues with a fix version set.": "لا توجد إصدارات متزامنة بعد — اربط Jira وزامن القضايا التي لها إصدار إصلاح محدد.",
  "No role requests yet": "لا توجد طلبات أدوار بعد",
  "No score history yet — a snapshot is recorded the next time an AI output is created or reviewed.": "لا يوجد سجل درجات بعد — تُسجَّل لقطة في المرة القادمة التي يُنشأ فيها مخرج ذكاء اصطناعي أو يُراجَع.",
  "No signals yet": "لا توجد إشارات بعد",
  "No stakeholders in this category": "لا يوجد أصحاب مصلحة في هذه الفئة",
  "No strategic pillars defined yet.": "لم تُحدَّد ركائز استراتيجية بعد.",
  "No sync history yet. Sync an integration to see results here.": "لا يوجد سجل مزامنة بعد. زامن تكاملًا لتظهر النتائج هنا.",
  "No synced projects available yet.": "لا توجد مشاريع متزامنة متاحة بعد.",
  "No tasks found": "لم يتم العثور على مهام",
  "No templates match your search.": "لا توجد قوالب تطابق بحثك.",
  "No text preview available.": "لا توجد معاينة نصية متاحة.",
  "No transcript available": "لا يوجد نص مفرّغ متاح",
  "No unread escalations.": "لا توجد تصعيدات غير مقروءة.",
  "No users found": "لم يتم العثور على مستخدمين",
  "No users yet — add your first teammate.": "لا يوجد مستخدمون بعد — أضف أول زميل في فريقك.",
  "None": "لا شي",
  "Not assessed": "غير مُقيَّم",
  "Not connected": "غير متصل",
  "Note": "ملاحظة",
  "Notes": "ملاحظات",
  "Nothing here": "لا شي هنا",
  "Nothing is blocked.": "ما فيه شي متعطل.",
  "Nothing scheduled": "لا شي مجدول",
  "Notification Settings Saved": "تم حفظ إعدادات الإشعارات",
  "Notification settings": "إعدادات الإشعارات",
  "Notifications": "الإشعارات",
  "Notion Pages": "صفحات Notion",
  "Oldest first": "الأقدم أولًا",
  "On Track": "على المسار",
  "On track": "على المسار",
  "OneDrive": "OneDrive",
  "OneDrive not connected": "OneDrive غير مرتبط",
  "Only PMO Head or Admin can toggle the kill switch.": "فقط رئيس مكتب إدارة المشاريع أو المسؤول يمكنه تشغيل مفتاح الإيقاف الطارئ.",
  "Only items that need action: risks, decisions, approvals and overdue work": "فقط العناصر التي تحتاج إجراء: المخاطر والقرارات والموافقات والأعمال المتأخرة",
  "Open": "فتح",
  "Open Ask Masira": "فتح اسأل Masira",
  "Open Findings": "النتائج المفتوحة",
  "Open Original": "فتح الأصل",
  "Open Signals by Severity": "الإشارات المفتوحة حسب الخطورة",
  "Open risks": "المخاطر المفتوحة",
  "Open rule firings": "قواعد مفعّلة مفتوحة",
  "Optional": "اختياري",
  "Optional details": "تفاصيل اختيارية",
  "Or paste transcript text": "أو الصق نص التفريغ",
  "Org": "المؤسسة",
  "Org Settings": "إعدادات المؤسسة",
  "Organization Users": "مستخدمو المؤسسة",
  "Other": "أخرى",
  "Outlook": "Outlook",
  "Output States": "حالات المخرجات",
  "Overall Progress": "التقدم الكلي",
  "Overdue follow-ups": "متابعات متأخرة",
  "Owner": "المالك",
  "Owner:": "المالك:",
  "PDF exported": "تم تصدير PDF",
  "PPTX exported": "تم تصدير PPTX",
  "Page Visits": "زيارات الصفحات",
  "Page navigation events": "أحداث التنقل بين الصفحات",
  "Password Changed": "تم تغيير كلمة المرور",
  "Password must be at least 6 characters.": "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
  "Paste meeting transcript here...": "الصق نص تفريغ الاجتماع هنا...",
  "Paste or type your document content here...": "الصق محتوى المستند أو اكتبه هنا...",
  "Pending": "معلّق",
  "Pending (": "معلّق (",
  "Pending Decisions": "القرارات المعلّقة",
  "People synced from your connected tools": "أشخاص متزامنون من أدواتك المرتبطة",
  "Per governance policy, this feature aggregates signals to support PMO decision-making without individual performance tracking.": "وفق سياسة الحوكمة، تجمّع هذه الميزة الإشارات لدعم قرارات مكتب إدارة المشاريع دون تتبّع أداء الأفراد.",
  "Per-project risk analysis": "تحليل المخاطر لكل مشروع",
  "Person (A-Z)": "الشخص (أ-ي)",
  "Personal": "شخصي",
  "Pick the folders whose documents Masira may read. Access is read-only and limited to the folders you select here.": "اختر المجلدات التي يحق لـ Masira قراءة مستنداتها. الوصول للقراءة فقط ومحصور بالمجلدات التي تختارها هنا.",
  "Pillar added": "تمت إضافة الركيزة",
  "Pitch Deck": "عرض المستثمرين",
  "Planned": "مخطط",
  "Planned vs Actual vs Forecast": "المخطط مقابل الفعلي مقابل المتوقع",
  "Platform Default (Masira shared relay)": "الافتراضي للمنصة (ترحيل Masira المشترك)",
  "Please enter a message": "الرجاء إدخال رسالة",
  "Please provide both title and content.": "الرجاء إدخال العنوان والمحتوى معًا.",
  "Please select a role": "الرجاء اختيار دور",
  "Please try again": "حاول مرة ثانية",
  "Please upload Excel (.xlsx, .xls), CSV, or Word (.docx) files": "الرجاء رفع ملفات Excel (.xlsx أو .xls) أو CSV أو Word (.docx)",
  "Policy": "السياسة",
  "Policy Name *": "اسم السياسة *",
  "Policy Registry": "سجل السياسات",
  "Policy created": "تم إنشاء السياسة",
  "Policy name required": "اسم السياسة مطلوب",
  "Policy saved": "تم حفظ السياسة",
  "Policy title": "عنوان السياسة",
  "Portfolio Governance": "حوكمة المحفظة",
  "Portfolio Health": "صحة المحفظة",
  "Portfolio Management": "إدارة المحفظة",
  "Portfolio Risk": "مخاطر المحفظة",
  "Portfolio Summary": "ملخص المحفظة",
  "Power:": "القوة:",
  "Powered by AI": "مدعوم بالذكاء الاصطناعي",
  "Presentation deleted": "تم حذف العرض التقديمي",
  "Presentation duplicated": "تم تكرار العرض التقديمي",
  "Presentation generated": "تم إنشاء العرض التقديمي",
  "Presentation name": "اسم العرض التقديمي",
  "Presentations": "العروض التقديمية",
  "Prevent inbox data from being used for HR or performance evaluation": "منع استخدام بيانات صندوق الوارد في التقييم الوظيفي أو تقييم الأداء",
  "Preview Heading": "معاينة العنوان",
  "Previous": "السابق",
  "Primary Button": "الزر الرئيسي",
  "Primary Channel": "القناة الرئيسية",
  "Primary Color": "اللون الرئيسي",
  "Priority": "الأولوية",
  "Priority Alerts": "التنبيهات ذات الأولوية",
  "Privacy": "الخصوصية",
  "Privacy & Transparency": "الخصوصية والشفافية",
  "Product Documentation": "وثائق المنتج",
  "Product Resources": "موارد المنتج",
  "Productivity": "الإنتاجية",
  "Profile": "الملف الشخصي",
  "Profile Information": "معلومات الملف الشخصي",
  "Profile Updated": "تم تحديث الملف الشخصي",
  "Progress": "التقدم",
  "Progress %": "التقدم %",
  "Progress towards organizational objectives": "التقدم نحو أهداف المؤسسة",
  "Project": "المشروع",
  "Project (": "المشروع (",
  "Project Blueprint": "مخطط المشروع",
  "Project Events": "أحداث المشروع",
  "Project ID": "معرّف المشروع",
  "Project ROI saved": "تم حفظ العائد على الاستثمار للمشروع",
  "Project Risk Overview": "نظرة عامة على مخاطر المشروع",
  "Project Templates": "قوالب المشاريع",
  "Project Timeline": "الجدول الزمني للمشروع",
  "Project Updates": "تحديثات المشروع",
  "Project files synced with OneDrive": "ملفات المشروع المتزامنة مع OneDrive",
  "Project removed": "تمت إزالة المشروع",
  "Project, portfolio, strategy and budget candidates detected from synced documents — review before they flow into Projects, Portfolio, or Budget.": "مشاريع ومحافظ واستراتيجيات وميزانيات مرشحة مكتشفة من المستندات المتزامنة — راجعها قبل أن تنتقل إلى المشاريع أو المحفظة أو الميزانية.",
  "Projects in this portfolio (required, at least one)": "المشاريع في هذه المحفظة (مطلوب، واحد على الأقل)",
  "Projects need attention": "مشاريع تحتاج اهتمامًا",
  "Projects:": "المشاريع:",
  "Prompt Manager": "مدير الموجّهات",
  "Provider": "المزود",
  "Published": "منشور",
  "Purpose": "الغرض",
  "Purpose *": "الغرض *",
  "Quarter label": "اسم الربع",
  "Quarter start date": "تاريخ بداية الربع",
  "Quarterly Performance": "الأداء الربعي",
  "Quarterly performance saved": "تم حفظ الأداء الربعي",
  "Query Knowledge Base": "الاستعلام من قاعدة المعرفة",
  "Query failed": "فشل الاستعلام",
  "Quick generate": "إنشاء سريع",
  "ROI by Project": "العائد على الاستثمار حسب المشروع",
  "Rate": "التقييم",
  "Rate Technical Complexity & Scope Creep": "قيّم التعقيد التقني وزحف النطاق",
  "Rationale": "المبررات",
  "Re-run Microsoft admin consent — only needed if permissions changed or access was revoked": "أعد تشغيل موافقة مسؤول Microsoft — يلزم فقط إذا تغيّرت الصلاحيات أو سُحب الوصول",
  "Read email": "قراءة البريد",
  "Real-time enterprise signals normalized from synthetic data generator": "إشارات مؤسسية فورية موحّدة من مولّد البيانات الاصطناعية",
  "Reason for halting AI outputs (required)": "سبب إيقاف مخرجات الذكاء الاصطناعي (مطلوب)",
  "Reason required to activate kill switch": "السبب مطلوب لتفعيل مفتاح الإيقاف الطارئ",
  "Reason:": "السبب:",
  "Reasoning": "الاستدلال",
  "Recent synchronization activity": "نشاط المزامنة الأخير",
  "Recognition": "التقدير",
  "Recommended": "موصى به",
  "Reconnect": "إعادة الاتصال",
  "Record Consent": "تسجيل الموافقة",
  "Recorded on every AI output creation and HITL review action": "يُسجَّل عند كل إنشاء لمخرج ذكاء اصطناعي وعند كل إجراء مراجعة بشرية",
  "Recording": "التسجيل",
  "Recording available": "التسجيل متاح",
  "Refresh": "تحديث",
  "Refreshing dashboard data...": "جارٍ تحديث بيانات لوحة المعلومات...",
  "Regenerate": "إعادة الإنشاء",
  "Register": "تسجيل",
  "Register AI Model": "تسجيل نموذج ذكاء اصطناعي",
  "Register Model": "تسجيل النموذج",
  "Register and govern AI models in use across the platform": "سجّل نماذج الذكاء الاصطناعي المستخدمة على المنصة وأدِرها",
  "Registered": "مُسجَّل",
  "Reject": "رفض",
  "Rejected": "مرفوض",
  "Rejected (": "مرفوض (",
  "Related project": "المشروع ذو الصلة",
  "Remove": "إزالة",
  "Remove folder": "إزالة المجلد",
  "Remove this folder?": "إزالة هذا المجلد؟",
  "Reply": "رد",
  "Replying to": "الرد على",
  "Report Generated": "تم إنشاء التقرير",
  "Report content copied to clipboard.": "تم نسخ محتوى التقرير إلى الحافظة.",
  "Report could not be created": "تعذّر إنشاء التقرير",
  "Report generation, risk analysis…": "إنشاء التقارير وتحليل المخاطر…",
  "Report has been downloaded as PDF.": "تم تنزيل التقرير بصيغة PDF.",
  "Reports are automatically generated by analyzing your project data including tasks, meetings, emails, and activity metrics. AI synthesizes this information into professional, actionable reports that would typically take hours to create manually.": "تُنشأ التقارير تلقائيًا بتحليل بيانات مشاريعك، من مهام واجتماعات وبريد ومؤشرات نشاط. يجمع الذكاء الاصطناعي هذه المعلومات في تقارير احترافية قابلة للتنفيذ كانت تستغرق عادةً ساعات لإعدادها يدويًا.",
  "Reprocess embeddings": "إعادة معالجة التضمينات",
  "Reprocessing complete": "اكتملت إعادة المعالجة",
  "Reprocessing failed": "فشلت إعادة المعالجة",
  "Request History": "سجل الطلبات",
  "Request More Evidence": "طلب مزيد من الأدلة",
  "Request Role Assignment": "طلب تعيين دور",
  "Requested": "تاريخ الطلب",
  "Requested On": "طُلب في",
  "Requested Role": "الدور المطلوب",
  "Require MFA": "اشتراط المصادقة متعددة العوامل",
  "Require all users in this organisation to enroll a TOTP authenticator app": "اشترط على كل مستخدمي هذه المؤسسة تسجيل تطبيق مصادقة TOTP",
  "Require human approval for all AI-generated outputs before publishing": "اشترط موافقة بشرية على كل مخرجات الذكاء الاصطناعي قبل النشر",
  "Resend": "إعادة الإرسال",
  "Resend API Key": "مفتاح Resend API",
  "Reset to Defaults": "إعادة الضبط للافتراضي",
  "Resolved": "تم الحل",
  "Resources": "الموارد",
  "Restore": "استعادة",
  "Restore failed": "فشلت الاستعادة",
  "Restore sync triggered": "بدأت مزامنة الاستعادة",
  "Restore this deleted record?": "استعادة هذا السجل المحذوف؟",
  "Restrict AI feature access to specific IP ranges (CIDR notation, one per line). Leave empty to allow all IPs.": "قيّد وصول ميزات الذكاء الاصطناعي بنطاقات عناوين IP محددة (صيغة CIDR، واحد في كل سطر). اتركه فارغًا للسماح بكل العناوين.",
  "Retire": "إيقاف",
  "Retired": "متوقف",
  "Retry": "إعادة المحاولة",
  "Returns": "العوائد",
  "Revenue": "الإيرادات",
  "Revenue, Cost & Profit trends": "اتجاهات الإيرادات والتكلفة والربح",
  "Review": "مراجعة",
  "Review AI Brief": "مراجعة ملخص الذكاء الاصطناعي",
  "Review Date": "تاريخ المراجعة",
  "Review Recommendation": "مراجعة التوصية",
  "Review Role Request": "مراجعة طلب الدور",
  "Review and approve role assignment requests from users": "راجع طلبات تعيين الأدوار من المستخدمين ووافق عليها",
  "Review and edit the suggested reply before sending.": "راجع الرد المقترح وعدّله قبل الإرسال.",
  "Review detected projects": "مراجعة المشاريع المكتشفة",
  "Review · Correct · Approve AI-generated outputs before they reach end users": "مراجعة · تصحيح · موافقة على مخرجات الذكاء الاصطناعي قبل وصولها للمستخدمين النهائيين",
  "Reviewed": "تمت المراجعة",
  "Reviewer note:": "ملاحظة المراجع:",
  "Risk": "الخطر",
  "Risk Mitigation Suggestions": "اقتراحات معالجة المخاطر",
  "Risk Score": "درجة الخطر",
  "Risk Signal Controls": "ضوابط إشارات المخاطر",
  "Risk activity": "نشاط المخاطر",
  "Risk entry logged": "تم تسجيل إدخال الخطر",
  "Risk factors saved": "تم حفظ عوامل الخطر",
  "Risk heat map": "خريطة حرارة المخاطر",
  "Risk heat map by likelihood and impact": "خريطة حرارة المخاطر حسب الاحتمال والأثر",
  "Risk watchlist": "قائمة مراقبة المخاطر",
  "Risks & Blockers": "المخاطر والعوائق",
  "Role": "الدور",
  "Role *": "الدور *",
  "Role Assignment": "تعيين الأدوار",
  "Role Requests": "طلبات الأدوار",
  "Role request approved": "تمت الموافقة على طلب الدور",
  "Role request rejected": "تم رفض طلب الدور",
  "Role request submitted! An admin will review your request.": "تم إرسال طلب الدور! سيراجعه المسؤول.",
  "Roll back": "تراجع",
  "Rules like review SLAs, checked live — no scheduler required to view breach status": "قواعد مثل اتفاقيات مستوى المراجعة، تُفحص مباشرة — لا حاجة لمجدول لعرض حالة المخالفات",
  "SAML 2.0": "SAML 2.0",
  "SOC 2": "SOC 2",
  "SSO Configuration Saved": "تم حفظ إعدادات SSO",
  "Save": "حفظ",
  "Save Allowlist": "حفظ القائمة",
  "Save Branding": "حفظ الهوية",
  "Save Changes": "حفظ التغييرات",
  "Save Correction": "حفظ التصحيح",
  "Save MCP Settings": "حفظ إعدادات MCP",
  "Save Notification Settings": "حفظ إعدادات الإشعارات",
  "Save Policy": "حفظ السياسة",
  "Save SSO Configuration": "حفظ إعدادات SSO",
  "Save as new version": "حفظ كنسخة جديدة",
  "Save failed": "فشل الحفظ",
  "Saved": "تم الحفظ",
  "Saved. It applies to everyone in your organisation.": "تم الحفظ. ينطبق على كل من في مؤسستك.",
  "Saves 2-4 hours per report": "يوفّر من ساعتين إلى 4 ساعات لكل تقرير",
  "Saving...": "جارٍ الحفظ...",
  "Scan Synced Data": "فحص البيانات المتزامنة",
  "Schedule Meeting": "جدولة اجتماع",
  "Schedule used": "الجدول المستخدم",
  "Scope Creep": "زحف النطاق",
  "Search action, record, person, notes": "ابحث في الإجراء أو السجل أو الشخص أو الملاحظات",
  "Search audit events": "ابحث في أحداث التدقيق",
  "Search decisions...": "ابحث في القرارات...",
  "Search documents...": "ابحث في المستندات...",
  "Search stakeholders...": "ابحث في أصحاب المصلحة...",
  "Search templates...": "ابحث في القوالب...",
  "Searchable": "قابل للبحث",
  "Secondary": "ثانوي",
  "Secondary Color": "اللون الثانوي",
  "Security": "الأمان",
  "See how your branding looks": "شاهد كيف تبدو هويتك",
  "Seed demo outputs": "إنشاء مخرجات تجريبية",
  "Seeded 3 demo AI outputs": "تم إنشاء 3 مخرجات ذكاء اصطناعي تجريبية",
  "Select Role to Request": "اختر الدور المطلوب",
  "Select a meeting and click analyze": "اختر اجتماعًا واضغط تحليل",
  "Select a meeting to view": "اختر اجتماعًا لعرضه",
  "Select a project": "اختر مشروعًا",
  "Select a project to view its risk analysis.": "اختر مشروعًا لعرض تحليل مخاطره.",
  "Select a signal to view": "اختر إشارة لعرضها",
  "Select fonts for headings and body text": "اختر الخطوط للعناوين والنصوص",
  "Select integration type": "اختر نوع التكامل",
  "Select provider…": "اختر المزود…",
  "Select this folder": "اختيار هذا المجلد",
  "Select type": "اختر النوع",
  "Selected:": "المحدد:",
  "Send": "إرسال",
  "Send Alerts Now": "إرسال التنبيهات الآن",
  "Send Communication": "إرسال رسالة تواصل",
  "Send Email": "إرسال بريد إلكتروني",
  "Send invite email": "إرسال بريد الدعوة",
  "Send message": "إرسال الرسالة",
  "Set": "تعيين",
  "Set Monthly Budget": "تعيين الميزانية الشهرية",
  "Set Project ROI": "تعيين العائد على الاستثمار للمشروع",
  "Set Quarterly Performance": "تعيين الأداء الربعي",
  "Set ROI": "تعيين العائد",
  "Set a temporary password now": "عيّن كلمة مرور مؤقتة الحين",
  "Set month": "تحديد الشهر",
  "Set quarter": "تحديد الربع",
  "Set up with Ask Masira": "الإعداد مع اسأل Masira",
  "Set your company name, logo, and tagline": "حدّد اسم شركتك وشعارها وعبارتها التعريفية",
  "Setting Updated": "تم تحديث الإعداد",
  "Settings": "الإعدادات",
  "Severity": "الخطورة",
  "Severity:": "الخطورة:",
  "Show": "عرض",
  "Show Resolved": "عرض المحلولة",
  "Show only aggregate sentiment trends, not individual scores": "اعرض اتجاهات المشاعر المجمّعة فقط، وليس الدرجات الفردية",
  "Show only risk indicators derived from meetings and delivery data": "اعرض فقط مؤشرات المخاطر المستخرجة من الاجتماعات وبيانات التنفيذ",
  "Showing 5 of": "عرض 5 من",
  "Showing candidates for loaded files only. Load more files to include the rest.": "يتم عرض المرشحين للملفات المحمّلة فقط. حمّل المزيد من الملفات لتشمل الباقي.",
  "Sign out": "تسجيل الخروج",
  "Signal Queue": "طابور الإشارات",
  "Signal Stream": "تدفق الإشارات",
  "Signals will appear here as project activity is detected": "ستظهر الإشارات هنا مع رصد نشاط المشاريع",
  "Signals with a generated brief": "إشارات لها ملخص مُنشأ",
  "Single Sign-On": "تسجيل الدخول الموحد",
  "Size": "الحجم",
  "Size Variants": "أحجام متعددة",
  "Skills": "المهارات",
  "Slide title": "عنوان الشريحة",
  "Small": "صغير",
  "Smart Task Suggestions": "اقتراحات المهام الذكية",
  "Something went wrong": "صار خطأ ما",
  "Sort by": "ترتيب حسب",
  "Source": "المصدر",
  "Source removed": "تمت إزالة المصدر",
  "Sources (": "المصادر (",
  "Speaker notes (optional)": "ملاحظات المتحدث (اختياري)",
  "Spent to Date": "المصروف حتى الآن",
  "Stakeholder Group": "مجموعة أصحاب المصلحة",
  "Start a document from a standard layout, or upload your own for the team": "ابدأ مستندًا من تخطيط قياسي، أو ارفع تخطيطك الخاص للفريق",
  "Start date": "تاريخ البدء",
  "Start time": "وقت البدء",
  "Start:": "البدء:",
  "Status": "الحالة",
  "Status Badges": "شارات الحالة",
  "Status Update Failed": "فشل تحديث الحالة",
  "Status Updated": "تم تحديث الحالة",
  "Status changes will be tracked here": "ستُتابَع تغييرات الحالة هنا",
  "Steps taken or planned to address this risk": "الخطوات المتخذة أو المخطط لها لمعالجة هذا الخطر",
  "Strategic Pillar Alignment": "مواءمة الركائز الاستراتيجية",
  "Strategic Pillars": "الركائز الاستراتيجية",
  "Strategic decisions requiring executive approval": "قرارات استراتيجية تحتاج موافقة تنفيذية",
  "Strategic insights • Last updated": "رؤى استراتيجية • آخر تحديث",
  "Subject Line": "سطر الموضوع",
  "Subject:": "الموضوع:",
  "Submit Request": "إرسال الطلب",
  "Suggest inviting to Masira": "اقتراح دعوته إلى Masira",
  "Suggested (": "مقترح (",
  "Suggested Actions": "الإجراءات المقترحة",
  "Suggested actions": "الإجراءات المقترحة",
  "Suggested match:": "التطابق المقترح:",
  "Suggestions ready": "الاقتراحات جاهزة",
  "Summary": "الملخص",
  "Sync Complete": "اكتملت المزامنة",
  "Sync History": "سجل المزامنة",
  "Sync Teams": "مزامنة Teams",
  "Sync all": "مزامنة الكل",
  "Sync complete": "اكتملت المزامنة",
  "Sync failed": "فشلت المزامنة",
  "Sync started": "بدأت المزامنة",
  "Synced data cleared": "تم مسح البيانات المتزامنة",
  "Synced from": "متزامن من",
  "Syncing": "جارٍ المزامنة",
  "Syncing files from OneDrive...": "جارٍ مزامنة الملفات من OneDrive...",
  "Synthetic Enterprise Signal Engine": "محرّك الإشارات المؤسسية الاصطناعية",
  "System prompts for every AI-generating function. Editing creates a new version — old versions stay available to roll back to.": "موجّهات النظام لكل وظيفة تولّد بالذكاء الاصطناعي. التعديل ينشئ نسخة جديدة — وتبقى النسخ القديمة متاحة للتراجع إليها.",
  "Tagline": "العبارة التعريفية",
  "Target %": "الهدف %",
  "Target:": "الهدف:",
  "Task": "المهمة",
  "Task added": "تمت إضافة المهمة",
  "Tasks Auto-Generated": "مهام مُنشأة تلقائيًا",
  "Tasks Completed": "المهام المكتملة",
  "Tasks Overdue": "المهام المتأخرة",
  "Tasks Overview": "نظرة عامة على المهام",
  "Tasks overdue:": "المهام المتأخرة:",
  "Team (": "الفريق (",
  "Team Management": "إدارة الفريق",
  "Team Members": "أعضاء الفريق",
  "Team Online": "الفريق المتصل",
  "Team Performance": "أداء الفريق",
  "Team Size": "حجم الفريق",
  "Team Skills Overview": "نظرة عامة على مهارات الفريق",
  "Team Velocity": "سرعة الفريق",
  "Team actions will appear here in real-time": "ستظهر إجراءات الفريق هنا لحظيًا",
  "Team template": "قالب الفريق",
  "Technical Complexity": "التعقيد التقني",
  "Template Name": "اسم القالب",
  "Template added": "تمت إضافة القالب",
  "Template content copied to clipboard.": "تم نسخ محتوى القالب إلى الحافظة.",
  "Template deleted": "تم حذف القالب",
  "Templates": "القوالب",
  "Templates must be 200 KB or smaller.": "يجب ألا يتجاوز حجم القوالب 200 كيلوبايت.",
  "Temporary Password *": "كلمة المرور المؤقتة *",
  "The Smart Inbox feature has been disabled by your organization's administrator. Contact your Tenant Admin for more information.": "تم تعطيل ميزة الصندوق الذكي من قبل مسؤول مؤسستك. تواصل مع مسؤول المؤسسة لمعرفة المزيد.",
  "The URL of your MCP server endpoint": "رابط نقطة نهاية خادم MCP",
  "The audit trail could not be loaded.": "تعذّر تحميل سجل التدقيق.",
  "The document has been removed from the knowledge base.": "تمت إزالة المستند من قاعدة المعرفة.",
  "The monthly chart appears once risks span three calendar months.": "يظهر المخطط الشهري عندما تمتد المخاطر على ثلاثة أشهر تقويمية.",
  "The provider connection is inactive.": "اتصال المزود غير نشط.",
  "The risk engine evaluates overdue work, blocked dependencies, and release health after every Jira sync.": "يقيّم محرّك المخاطر الأعمال المتأخرة والاعتماديات المتعطلة وصحة الإصدارات بعد كل مزامنة مع Jira.",
  "The suggested project match was dismissed.": "تم تجاهل المشروع المقترح للتطابق.",
  "The synced record and its tasks were deleted.": "تم حذف السجل المتزامن ومهامه.",
  "The template has been removed.": "تمت إزالة القالب.",
  "Theme Settings": "إعدادات المظهر",
  "These settings apply to all users in your organization. Changes take effect immediately.": "تنطبق هذه الإعدادات على كل مستخدمي مؤسستك. تسري التغييرات فورًا.",
  "This Month": "هذا الشهر",
  "This Week": "هذا الأسبوع",
  "This email has been linked to the suggested project.": "تم ربط هذا البريد بالمشروع المقترح.",
  "This email has no Outlook message id on record, so a reply cannot be sent.": "لا يوجد معرّف رسالة Outlook لهذا البريد، لذلك لا يمكن إرسال رد.",
  "This is how your body text will look with the selected font.": "هكذا سيظهر نص المحتوى بالخط المحدد.",
  "This permanently deletes every synced project and task record with source \"": "سيؤدي هذا إلى حذف كل سجلات المشاريع والمهام المتزامنة نهائيًا من المصدر \"",
  "This permanently deletes this project and its synced tasks from \"": "سيؤدي هذا إلى حذف هذا المشروع ومهامه المتزامنة نهائيًا من \"",
  "This project currently has no open risk signals, or the available evidence is too thin to responsibly suggest anything.": "لا يحتوي هذا المشروع حاليًا على إشارات مخاطر مفتوحة، أو أن الأدلة المتاحة قليلة جدًا لاقتراح شي بمسؤولية.",
  "This removes the connection and its stored credentials. It won't affect the app's saved data unless you choose to clear it below.": "يزيل هذا الاتصال وبيانات اعتماده المخزّنة. ولا يؤثر على بيانات التطبيق المحفوظة ما لم تختر مسحها أدناه.",
  "This revokes their access to this organization. It does not delete their account.": "يسحب هذا وصوله إلى هذه المؤسسة. ولا يحذف حسابه.",
  "This triggers a re-sync of \"": "سيؤدي هذا إلى إعادة مزامنة \"",
  "This view shows aggregate communication signals only. Individual sentiment scoring is disabled. Selecting a project shows real per-project communication signals (unanswered threads, response time, escalations, volume trend). Data is not used for HR or performance evaluation.": "يعرض هذا القسم إشارات التواصل المجمّعة فقط. تقييم المشاعر الفردي معطّل. اختيار مشروع يعرض إشارات تواصل فعلية لكل مشروع (المحادثات دون رد، زمن الاستجابة، التصعيدات، اتجاه الحجم). البيانات لا تُستخدم للتقييم الوظيفي أو تقييم الأداء.",
  "This week": "هذا الأسبوع",
  "Threads awaiting a reply, across all projects": "محادثات بانتظار رد، في كل المشاريع",
  "Time": "الوقت",
  "Time Saved": "الوقت الموفَّر",
  "Time to first reply": "زمن أول رد",
  "Timeline": "الجدول الزمني",
  "Timestamp": "الطابع الزمني",
  "Title": "العنوان",
  "Title *": "العنوان *",
  "Title is required": "العنوان مطلوب",
  "Title required": "العنوان مطلوب",
  "Today's Activity": "نشاط اليوم",
  "Top Pages": "أكثر الصفحات زيارة",
  "Total Actions": "إجمالي الإجراءات",
  "Total Entries": "إجمالي الإدخالات",
  "Total Escalations": "إجمالي التصعيدات",
  "Total Investment": "إجمالي الاستثمار",
  "Total Projects": "إجمالي المشاريع",
  "Total Returns": "إجمالي العوائد",
  "Total Signals": "إجمالي الإشارات",
  "Total Unanswered": "إجمالي ما لم يُرَد عليه",
  "Track all status changes for AI-generated outputs": "تابع كل تغييرات حالة مخرجات الذكاء الاصطناعي",
  "Track and record executive decisions with full audit trail": "تابع القرارات التنفيذية وسجّلها بمسار تدقيق كامل",
  "Track and resolve project issues, blockers, and escalations": "تابع مشكلات المشاريع والعوائق والتصعيدات وعالجها",
  "Track the lifecycle of AI-generated content from draft to publication": "تابع دورة حياة المحتوى المُنشأ بالذكاء الاصطناعي من المسودة حتى النشر",
  "Track your daily productivity and AI impact": "تابع إنتاجيتك اليومية وأثر الذكاء الاصطناعي",
  "Transcript file (.vtt, .txt)": "ملف النص المفرّغ (.vtt أو .txt)",
  "Transcript uploaded and analyzed": "تم رفع النص المفرّغ وتحليله",
  "Trend": "الاتجاه",
  "Truncated": "مقتطع",
  "Trust Indicators": "مؤشرات الثقة",
  "Trusted": "موثوق",
  "Trustworthy AI Controls": "ضوابط الذكاء الاصطناعي الموثوق",
  "Type": "النوع",
  "Type your reply...": "اكتب ردك...",
  "Typography": "الخطوط",
  "Unanswered Threads": "المحادثات دون رد",
  "Unassigned": "غير مُسنَد",
  "Under Review": "قيد المراجعة",
  "Understand and control what data the AI can access to provide recommendations": "افهم وتحكّم في البيانات التي يمكن للذكاء الاصطناعي الوصول إليها لتقديم التوصيات",
  "Understand how this report was generated": "افهم كيف أُنشئ هذا التقرير",
  "Understand, control, and verify AI-powered features": "افهم ميزات الذكاء الاصطناعي وتحكّم فيها وتحقق منها",
  "Unread": "غير مقروء",
  "Unread email": "بريد غير مقروء",
  "Unsupported file": "ملف غير مدعوم",
  "Up": "ارتفاع",
  "Upcoming": "القادم",
  "Update Password": "تحديث كلمة المرور",
  "Update failed": "فشل التحديث",
  "Update your password to keep your account secure": "حدّث كلمة مرورك للحفاظ على أمان حسابك",
  "Update your profile details and photo": "حدّث بيانات ملفك الشخصي وصورتك",
  "Update:": "التحديث:",
  "Updated": "تم التحديث",
  "Upload": "رفع",
  "Upload & Analyze": "رفع وتحليل",
  "Upload Document": "رفع مستند",
  "Upload Excel, CSV, Word, or PowerPoint files to import project data": "ارفع ملفات Excel أو CSV أو Word أو PowerPoint لاستيراد بيانات المشاريع",
  "Upload Failed": "فشل الرفع",
  "Upload File": "رفع ملف",
  "Upload Logo": "رفع الشعار",
  "Upload Photo": "رفع صورة",
  "Upload Template": "رفع قالب",
  "Upload Transcript": "رفع نص مفرّغ",
  "Upload documents and query your company knowledge with AI": "ارفع المستندات واستعلم عن معرفة شركتك بالذكاء الاصطناعي",
  "Upload failed": "فشل الرفع",
  "Upload or paste transcript to analyze": "ارفع نصًا مفرّغًا أو الصقه للتحليل",
  "Uploaded": "تم الرفع",
  "Uploaded Documents": "المستندات المرفوعة",
  "Uploading...": "جارٍ الرفع...",
  "Use": "استخدام",
  "Use Case": "حالة الاستخدام",
  "Use Template": "استخدام القالب",
  "Users without a verified TOTP factor will be redirected to MFA setup on next login": "سيُحوَّل المستخدمون بلا عامل TOTP موثّق إلى إعداد المصادقة متعددة العوامل عند تسجيل الدخول القادم",
  "Velocity": "السرعة",
  "Verified and approved executive summaries": "ملخصات تنفيذية موثّقة ومعتمدة",
  "Version": "النسخة",
  "Version history (": "سجل النسخ (",
  "View": "عرض",
  "View All": "عرض الكل",
  "View Profile": "عرض الملف الشخصي",
  "View Report": "عرض التقرير",
  "View all": "عرض الكل",
  "View and export the product pitch deck": "اعرض عرض المستثمرين وصدّره",
  "View in Action Hub": "عرض في مركز الإجراءات",
  "Viewing": "يتم العرض",
  "Viewing as": "العرض بصفة",
  "Visual indicators showing content source and verification status": "مؤشرات مرئية توضح مصدر المحتوى وحالة التحقق منه",
  "Volume Trend": "اتجاه الحجم",
  "Week Highlights": "أبرز أحداث الأسبوع",
  "Weekly AI Efficiency": "كفاءة الذكاء الاصطناعي الأسبوعية",
  "Weekly Activity Overview": "نظرة عامة على النشاط الأسبوعي",
  "Weekly digest generated successfully": "تم إنشاء الملخص الأسبوعي بنجاح",
  "What did you change and why? (optional)": "وش اللي غيّرته وليش؟ (اختياري)",
  "What happened? How was it detected?": "وش اللي صار؟ وكيف تم اكتشافه؟",
  "What needs to happen?": "وش المطلوب عمله؟",
  "Why": "السبب",
  "Why Am I Seeing This?": "ليش أشوف هذا؟",
  "Why am I seeing this": "ليش أشوف هذا",
  "Why am I seeing this?": "ليش أشوف هذا؟",
  "Why is this signal not actionable? (required)": "ليش هذه الإشارة غير قابلة للتنفيذ؟ (مطلوب)",
  "Why this decision...": "سبب هذا القرار...",
  "Withdrawn": "مسحوب",
  "Word": "Word",
  "Workload": "عبء العمل",
  "Workload Distribution": "توزيع عبء العمل",
  "X.509 Certificate (PEM)": "شهادة X.509 (PEM)",
  "You already have a pending request for this role": "لديك طلب معلّق لهذا الدور بالفعل",
  "You cannot modify your own role": "لا يمكنك تعديل دورك بنفسك",
  "You don't have permission to access this feature. Contact your administrator if you believe this is an error.": "ما عندك صلاحية الوصول لهذه الميزة. تواصل مع المسؤول إذا كنت تعتقد أن هذا خطأ.",
  "You have": "لديك",
  "You have unsaved changes": "لديك تغييرات غير محفوظة",
  "You haven't made any role requests yet": "ما قدّمت أي طلبات أدوار بعد",
  "You need administrator privileges to access branding and template settings.": "تحتاج صلاحيات المسؤول للوصول إلى إعدادات الهوية والقوالب.",
  "Your MCP server authentication key": "مفتاح مصادقة خادم MCP الخاص بك",
  "Your Presentations": "عروضك التقديمية",
  "Your Templates": "قوالبك",
  "Your avatar has been updated.": "تم تحديث صورتك الشخصية.",
  "Your company branding has been updated.": "تم تحديث هوية شركتك.",
  "Your current role is": "دورك الحالي هو",
  "Your document has been added to the knowledge base.": "تمت إضافة مستندك إلى قاعدة المعرفة.",
  "Your document template has been saved.": "تم حفظ قالب مستندك.",
  "Your email template has been saved.": "تم حفظ قالب بريدك الإلكتروني.",
  "Your knowledge base contains": "تحتوي قاعدة معرفتك على",
  "Your logo has been uploaded. Click Save to apply.": "تم رفع شعارك. اضغط حفظ للتطبيق.",
  "Your password has been updated successfully.": "تم تحديث كلمة مرورك بنجاح.",
  "Your profile has been updated successfully.": "تم تحديث ملفك الشخصي بنجاح.",
  "Your role:": "دورك:",
  "active": "نشط",
  "active range": "النطاق النشط",
  "allocation": "التخصيص",
  "analyzed": "تم تحليله",
  "at risk": "معرّض للخطر",
  "attendees •": "الحضور •",
  "awaiting": "بانتظار",
  "awaiting review": "بانتظار المراجعة",
  "blocked": "متعطل",
  "blocked issue": "مشكلة متعطلة",
  "connected": "متصل",
  "connections — this clears data for all of them, not just this one.": "اتصالات — سيمسح هذا بيانات كل هذه الاتصالات وليس واحدًا فقط.",
  "content...": "المحتوى...",
  "could not be matched to a project (release with no synced tasks, or a task with no project reference) and are not shown below.": "تعذّر ربطها بمشروع (إصدار بلا مهام متزامنة، أو مهمة بلا مرجع مشروع) ولا تظهر أدناه.",
  "critical alert": "تنبيه حرج",
  "data point": "نقطة بيانات",
  "days. Connect Microsoft 365 or Teams under Integrations and they will appear here.": "أيام. اربط Microsoft 365 أو Teams من صفحة التكاملات وستظهر هنا.",
  "detected project": "مشروع مكتشف",
  "document(s)": "مستند(ات)",
  "done": "مكتملة",
  "e.g. Northstar": "مثال: Northstar",
  "e.g. Project Phoenix": "مثال: Project Phoenix",
  "e.g. Project analytics, AI-assisted reporting": "مثال: تحليلات المشاريع، التقارير بمساعدة الذكاء الاصطناعي",
  "e.g. Reports reviewed within 24h": "مثال: مراجعة التقارير خلال 24 ساعة",
  "e.g. llama-3.3-70b-versatile": "مثال: llama-3.3-70b-versatile",
  "e.g., Company Policies, Product FAQ...": "مثال: سياسات الشركة، الأسئلة الشائعة عن المنتج...",
  "escalated": "مُصعَّد",
  "failed": "فشل",
  "failed sync": "مزامنة فاشلة",
  "files": "ملفات",
  "filter": "تصفية",
  "folder": "مجلد",
  "from this organization?": "من هذه المؤسسة؟",
  "h pending": "ساعة معلّقة",
  "high priority": "أولوية عالية",
  "in Supabase Edge Function secrets to enable the platform default relay without per-tenant configuration.": "في أسرار Supabase Edge Function لتفعيل الترحيل الافتراضي للمنصة دون إعداد لكل مؤسسة.",
  "in progress": "قيد التنفيذ",
  "initiatives completed": "مبادرات مكتملة",
  "is requesting the": "يطلب الدور",
  "issue": "مشكلة",
  "items": "عناصر",
  "level": "المستوى",
  "mapped yet.": "لم يُربط بعد.",
  "members)": "أعضاء)",
  "min saved": "دقيقة موفَّرة",
  "more": "المزيد",
  "more (": "المزيد (",
  "more in Decisions and Approvals": "المزيد في القرارات والموافقات",
  "more suggestions": "مزيد من الاقتراحات",
  "ms": "مللي ثانية",
  "n8n Workflows": "مسارات n8n",
  "new": "جديد",
  "of": "من",
  "off track": "خارج المسار",
  "on track": "على المسار",
  "online": "متصل",
  "open risk": "خطر مفتوح",
  "output(s) currently exceed their policy's review SLA": "مخرجات تتجاوز حاليًا اتفاقية مستوى المراجعة في سياستها",
  "overdue": "متأخر",
  "pending": "معلّق",
  "priority": "الأولوية",
  "project": "مشروع",
  "projects": "مشاريع",
  "projects have open risks. Select a project to open it.": "مشاريع فيها مخاطر مفتوحة. اختر مشروعًا لفتحه.",
  "records": "سجلات",
  "remaining)": "متبقٍ)",
  "removed": "تمت الإزالة",
  "requiring attention": "تحتاج اهتمامًا",
  "role": "الدور",
  "searchable chunks": "مقاطع قابلة للبحث",
  "signal": "إشارة",
  "signals": "إشارات",
  "slides": "شرائح",
  "spent": "المصروف",
  "stakeholder(s)": "صاحب(أصحاب) مصلحة",
  "syntax for dynamic placeholders": "الصيغة للعناصر البديلة الديناميكية",
  "tasks done": "مهام مكتملة",
  "tasks in progress": "مهام قيد التنفيذ",
  "total": "الإجمالي",
  "unread": "غير مقروء",
  "upcoming": "قادم",
  "useful before a resync if old data turned out to be stale or malformed. The integration connection itself is kept; run \"Sync Now\" afterward to repopulate it.": "مفيد قبل إعادة المزامنة إذا تبيّن أن البيانات القديمة قديمة أو تالفة. يبقى اتصال التكامل نفسه؛ شغّل «مزامنة الآن» بعدها لإعادة تعبئته.",
  "· Last synced": "· آخر مزامنة",
  "· detected": "· اكتُشف",
  "· policy \"": "· سياسة \"",
  "· review within": "· المراجعة خلال",
  "— see the Why tab for all": "— انظر تبويب «لماذا» للاطلاع على الكل",
  "” and permanently delete the files and search chunks it ingested from it. Your Drive files are not changed.": "» ونهائيًا حذف الملفات والمقاطع القابلة للبحث التي استوردها منه. ملفاتك على Drive لا تتغير.",
  "• Reviewed": "• تمت المراجعة",
  // ---- pass 2: assembled sentences, lookup-table labels, statuses ----
  " (current)": " (الحالي)",
  " (embedding failed)": " (فشل التضمين)",
  " · all up to date": " · كل شي محدّث",
  " · behind plan": " · متأخر عن الخطة",
  " · due {0}": " · الاستحقاق {0}",
  " · last sync {0}": " · آخر مزامنة {0}",
  " · last synced {0}": " · آخر مزامنة {0}",
  " · not synced yet": " · لم تتم المزامنة بعد",
  " · over pace": " · أسرع من المعدّل",
  " · reviewed {0}": " · تمت المراجعة {0}",
  " · {0} action item{1}": " · {0} بنود إجراء",
  " · {0} need attention": " · {0} تحتاج اهتمامًا",
  " · {0} of {1} events": " · {0} من {1} أحداث",
  "\"{0}\" has been added to your calendar.": "تمت إضافة \"{0}\" إلى تقويمك.",
  "% average progress": "% متوسط التقدم",
  "1024 dims, padded to 1536": "1024 بُعدًا، تُكمَّل إلى 1536",
  "1024 dims, padded to 1536, multilingual incl. Arabic": "1024 بُعدًا، تُكمَّل إلى 1536، متعدد اللغات ويشمل العربية",
  "1536 dims, legacy": "1536 بُعدًا، قديم",
  "1536 dims, recommended": "1536 بُعدًا، موصى به",
  "2 high-priority risks identified. Mitigation plans approved and in progress.": "تم تحديد خطرين عاليي الأولوية. خطط المعالجة معتمدة وقيد التنفيذ.",
  "5 tasks from meeting transcript": "5 مهام من نص تفريغ الاجتماع",
  "768 dims, padded to 1536": "768 بُعدًا، تُكمَّل إلى 1536",
  "A PMO dashboard is only useful when its evidence is current.": "لوحة مكتب إدارة المشاريع لا تفيد إلا إذا كانت أدلتها محدّثة.",
  "A team member has reviewed the content": "راجع أحد أعضاء الفريق المحتوى",
  "AI Analyzed": "حلّله الذكاء الاصطناعي",
  "AI Drafted": "صاغه الذكاء الاصطناعي",
  "AI Extracted": "استخرجه الذكاء الاصطناعي",
  "AI Generated": "أنشأه الذكاء الاصطناعي",
  "AI Prediction": "توقّع الذكاء الاصطناعي",
  "AI Processing": "معالجة الذكاء الاصطناعي",
  "AI Report": "تقرير الذكاء الاصطناعي",
  "AI Review": "مراجعة الذكاء الاصطناعي",
  "AI Suggestion": "اقتراح الذكاء الاصطناعي",
  "AI automation saved you 23.5 hours this week, equivalent to 3 full working days.": "وفّرت لك أتمتة الذكاء الاصطناعي 23.5 ساعة هذا الأسبوع، أي ما يعادل 3 أيام عمل كاملة.",
  "AI has generated content that needs human review": "أنشأ الذكاء الاصطناعي محتوى يحتاج مراجعة بشرية",
  "AI has helped complete tasks {0}% faster": "ساعد الذكاء الاصطناعي في إنجاز المهام أسرع بنسبة {0}%",
  "AI incident log maintained": "سجل حوادث الذكاء الاصطناعي محدّث",
  "AI model registry up-to-date": "سجل نماذج الذكاء الاصطناعي محدّث",
  "AI output requires human review before release.": "مخرجات الذكاء الاصطناعي تحتاج مراجعة بشرية قبل الإصدار.",
  "AI outputs awaiting review": "مخرجات ذكاء اصطناعي بانتظار المراجعة",
  "AI outputs halted": "تم إيقاف مخرجات الذكاء الاصطناعي",
  "AI outputs resumed": "تم استئناف مخرجات الذكاء الاصطناعي",
  "AI outputs subject to human review before publishing": "مخرجات الذكاء الاصطناعي تخضع لمراجعة بشرية قبل النشر",
  "AI recommendation": "توصية الذكاء الاصطناعي",
  "AI-drafted": "صياغة الذكاء الاصطناعي",
  "API Testing": "اختبار API",
  "API Token": "رمز API",
  "Accepted": "مقبول",
  "Access is now unrestricted.": "الوصول أصبح غير مقيّد.",
  "Across all projects": "في كل المشاريع",
  "Action item approved": "تمت الموافقة على بند الإجراء",
  "Action item updated": "تم تحديث بند الإجراء",
  "Activate Kill Switch": "تفعيل مفتاح الإيقاف الطارئ",
  "Active filter": "التصفية النشطة",
  "Active risk factors in the project": "عوامل الخطر النشطة في المشروع",
  "Add Integration": "إضافة تكامل",
  "Add folder & sync": "إضافة المجلد والمزامنة",
  "Adding…": "جارٍ الإضافة…",
  "Admin Dashboard": "لوحة المسؤول",
  "Administrator": "مسؤول",
  "Agenda and notes for a project kickoff with stakeholders": "جدول الأعمال والملاحظات لاجتماع انطلاق المشروع مع أصحاب المصلحة",
  "Agile": "أجايل",
  "All Issues": "كل المشكلات",
  "All active": "الكل نشط",
  "All ingested files have been analyzed.": "تم تحليل كل الملفات المستوردة.",
  "All major initiatives on track. Digital transformation at 87% completion.": "كل المبادرات الرئيسية على المسار. التحول الرقمي عند 87% من الإنجاز.",
  "All outputs": "كل المخرجات",
  "Analyze & Suggest": "تحليل واقتراح",
  "Analyzed": "تم تحليله",
  "Analyzing {0} document(s)...": "جارٍ تحليل {0} مستند(ات)...",
  "Analyzing...": "جارٍ التحليل...",
  "Anthropic (OpenAI-compatible proxy)": "Anthropic (وسيط متوافق مع OpenAI)",
  "Apply budget to project (required)": "تطبيق الميزانية على المشروع (مطلوب)",
  "Approve AI Output": "الموافقة على مخرج الذكاء الاصطناعي",
  "Approve Action Item": "الموافقة على بند الإجراء",
  "Approve Document Candidate": "الموافقة على المستند المرشح",
  "Arabic": "العربية",
  "Assigned to projects": "مُسنَدون إلى مشاريع",
  "At-risk status": "حالة معرّض للخطر",
  "Audit Flag": "علامة تدقيق",
  "Audit Log Failed": "فشل سجل التدقيق",
  "Australian dollar": "دولار أسترالي",
  "Authenticates via your organization’s Microsoft Entra app — no token needed here.": "يصادق عبر تطبيق Microsoft Entra الخاص بمؤسستك — لا حاجة لرمز هنا.",
  "Authentication failed": "فشلت المصادقة",
  "Avg Focus Score": "متوسط درجة التركيز",
  "Avg risk now": "متوسط الخطر الآن",
  "Backup Region": "المنطقة الاحتياطية",
  "Bahraini dinar": "دينار بحريني",
  "Based on spending patterns and project timeline": "بناءً على أنماط الإنفاق والجدول الزمني للمشروع",
  "Based on your calendar and team availability": "بناءً على تقويمك وتوفّر الفريق",
  "Benefits realization tracking in place": "متابعة تحقق المنافع مطبّقة",
  "Blocked dependency": "اعتمادية متعطلة",
  "Blocked work": "عمل متعطل",
  "Brazilian real": "ريال برازيلي",
  "Budget Constraints": "قيود الميزانية",
  "Budget Drift": "انحراف الميزانية",
  "Budget Status": "حالة الميزانية",
  "Budget Variance": "تباين الميزانية",
  "Business Proposal": "عرض تجاري",
  "Calendar & Meetings": "التقويم والاجتماعات",
  "Canadian dollar": "دولار كندي",
  "Candid": "صريح",
  "Candidate approved": "تمت الموافقة على المرشح",
  "Candidate approved and routed": "تمت الموافقة على المرشح وتوجيهه",
  "Candidate rejected": "تم رفض المرشح",
  "Catastrophic": "كارثي",
  "Change template": "تغيير القالب",
  "Changed priority of API integration": "تم تغيير أولوية تكامل API",
  "Changes apply for everyone in your organisation.": "تسري التغييرات على كل من في مؤسستك.",
  "Check that Microsoft 365 is connected and the Outlook integration has Mail.Read permission. Showing cached/demo data in the meantime.": "تأكد من ربط Microsoft 365 ومن أن تكامل Outlook يملك صلاحية Mail.Read. تُعرض بيانات مخزّنة/تجريبية في الوقت الحالي.",
  "Checking connection…": "جارٍ التحقق من الاتصال…",
  "Chinese yuan": "يوان صيني",
  "Choose a location": "اختر موقعًا",
  "Cloud Migration": "الترحيل السحابي",
  "Cloud migration delivering 34% cost savings ahead of schedule.": "الترحيل السحابي يحقق وفرًا في التكاليف بنسبة 34% قبل الموعد.",
  "Communication Matrix": "مصفوفة التواصل",
  "Communications": "المراسلات",
  "Comprehensive overview of weekly progress, accomplishments, and upcoming tasks": "نظرة شاملة على التقدم الأسبوعي والإنجازات والمهام القادمة",
  "Comprehensive risk analysis with mitigation strategies and trend analysis": "تحليل شامل للمخاطر مع استراتيجيات المعالجة وتحليل الاتجاهات",
  "Concise": "مختصر",
  "Connect Google Drive": "ربط Google Drive",
  "Connect Microsoft 365": "ربط Microsoft 365",
  "Connect to an external data source": "الربط بمصدر بيانات خارجي",
  "Consent mechanisms in place for personal data collection": "آليات الموافقة مطبّقة لجمع البيانات الشخصية",
  "Content approved by authorized personnel": "المحتوى معتمد من أشخاص مخوّلين",
  "Content is live and visible to stakeholders": "المحتوى منشور وظاهر لأصحاب المصلحة",
  "Correct AI Output": "تصحيح مخرج الذكاء الاصطناعي",
  "Corrected": "مصحَّح",
  "Corrected & Accepted": "مصحَّح ومقبول",
  "Correction saved and signal accepted": "تم حفظ التصحيح وقبول الإشارة",
  "Could not load Outlook emails": "تعذّر تحميل رسائل Outlook",
  "Could not reach the provider": "تعذّر الوصول إلى المزود",
  "Could not record status change": "تعذّر تسجيل تغيير الحالة",
  "Create Email Template": "إنشاء قالب بريد إلكتروني",
  "Create Issue": "إنشاء مشكلة",
  "Create Template": "إنشاء قالب",
  "Create a new document template": "إنشاء قالب مستند جديد",
  "Create another report": "إنشاء تقرير آخر",
  "Create your first decision to get started": "أنشئ أول قرار لك للبدء",
  "Critical Decisions Needed": "قرارات حرجة مطلوبة",
  "Critical or at risk": "حرج أو معرّض للخطر",
  "Critical status": "حالة حرجة",
  "Cross-border data transfer controls implemented": "ضوابط نقل البيانات عبر الحدود مطبّقة",
  "Cross-team dependencies": "اعتماديات بين الفرق",
  "Current team capacity vs upcoming tasks": "طاقة الفريق الحالية مقابل المهام القادمة",
  "Custom": "مخصص",
  "Custom OpenAI-compatible": "مخصص متوافق مع OpenAI",
  "Customize": "تخصيص",
  "Customize as a team template": "تخصيص كقالب للفريق",
  "Customize {0}": "تخصيص {0}",
  "Dashboard": "لوحة المعلومات",
  "Data Analytics Pipeline": "مسار تحليلات البيانات",
  "Data catalog maintained and up-to-date": "فهرس البيانات محدّث ومُصان",
  "Data classification policy documented": "سياسة تصنيف البيانات موثّقة",
  "Data freshness": "حداثة البيانات",
  "Data lineage documented for critical datasets": "تسلسل البيانات موثّق لمجموعات البيانات الحرجة",
  "Data ownership assigned per domain": "ملكية البيانات مُسنَدة لكل مجال",
  "Data ownership, quality and lineage": "ملكية البيانات وجودتها وتسلسلها",
  "Data quality metrics tracked": "مؤشرات جودة البيانات متابَعة",
  "Data retention schedules defined": "جداول الاحتفاظ بالبيانات محددة",
  "Data subject rights procedures established (access, deletion)": "إجراءات حقوق أصحاب البيانات مطبّقة (الوصول، الحذف)",
  "Data subject rights — access, rectification, erasure, and portability of personal data.": "حقوق أصحاب البيانات — الوصول إلى البيانات الشخصية وتصحيحها ومحوها ونقلها.",
  "Decision marked as {0}": "تم تعليم القرار كـ {0}",
  "Deferred": "مؤجَّل",
  "Delete {0}": "حذف {0}",
  "Dependency Delay": "تأخر اعتمادية",
  "Design": "التصميم",
  "Detailed monthly analysis with KPIs, budget status, and strategic insights": "تحليل شهري مفصّل مع مؤشرات الأداء وحالة الميزانية ورؤى استراتيجية",
  "Detected communication gaps in recent activity": "تم رصد فجوات تواصل في النشاط الأخير",
  "Digital Transformation": "التحول الرقمي",
  "Disconnect": "فصل",
  "Disconnect Google Drive?": "فصل Google Drive؟",
  "Disconnect and delete data": "فصل وحذف البيانات",
  "Edit Email Template": "تعديل قالب البريد الإلكتروني",
  "Edit Integration": "تعديل التكامل",
  "Edit Issue": "تعديل المشكلة",
  "Edit Template": "تعديل القالب",
  "Edit {0}": "تعديل {0}",
  "Egyptian pound": "جنيه مصري",
  "Emails Processed": "الرسائل المعالَجة",
  "Emails and messages in your inbox": "الرسائل الواردة في صندوقك",
  "Enable AI auto-replies for routine emails to save an additional 5+ hours weekly.": "فعّل الردود التلقائية بالذكاء الاصطناعي للرسائل الروتينية لتوفير أكثر من 5 ساعات إضافية أسبوعيًا.",
  "Enable/Disable All": "تفعيل/تعطيل الكل",
  "Endpoint or model not found": "نقطة النهاية أو النموذج غير موجود",
  "Engineering": "الهندسة",
  "English": "الإنجليزية",
  "Enterprise Platform Migration": "ترحيل المنصة المؤسسية",
  "Entity ID / Issuer": "معرّف الكيان / المُصدِر",
  "Escalate AI Output": "تصعيد مخرج الذكاء الاصطناعي",
  "Escalation": "تصعيد",
  "Euro": "يورو",
  "Every hour": "كل ساعة",
  "Everything": "كل شي",
  "Excel / CSV": "Excel / CSV",
  "Exceptions": "الاستثناءات",
  "Executive": "تنفيذي",
  "Executive Nudge": "تنبيه تنفيذي",
  "Executive Weekly Digest - Week 18": "الملخص الأسبوعي التنفيذي - الأسبوع 18",
  "Executive-level summary for stakeholders with key decisions and project health": "ملخص على المستوى التنفيذي لأصحاب المصلحة مع القرارات الرئيسية وصحة المشاريع",
  "Extracted": "مستخرَج",
  "Extracted files waiting for candidate analysis.": "ملفات مستخرجة بانتظار تحليل المرشحين.",
  "Extreme": "شديد",
  "Failed": "فشل",
  "Failed to clear signals: {0}": "تعذّر مسح الإشارات: {0}",
  "Failed to confirm the project match. Please try again.": "تعذّر تأكيد تطابق المشروع. حاول مرة ثانية.",
  "Failed to dismiss the project match. Please try again.": "تعذّر تجاهل تطابق المشروع. حاول مرة ثانية.",
  "Failed to generate AI reply. Please try again.": "تعذّر إنشاء رد الذكاء الاصطناعي. حاول مرة ثانية.",
  "Failed to generate report": "تعذّر إنشاء التقرير",
  "Failed to generate report. Please try again.": "تعذّر إنشاء التقرير. حاول مرة ثانية.",
  "Failed to generate signals: {0}": "تعذّر إنشاء الإشارات: {0}",
  "Failed to get response": "تعذّر الحصول على رد",
  "Failed to record review: {0}": "تعذّر تسجيل المراجعة: {0}",
  "Failed to scan synced data: {0}": "تعذّر فحص البيانات المتزامنة: {0}",
  "Failed to send invite": "تعذّر إرسال الدعوة",
  "Failed to send reply. Please try again.": "تعذّر إرسال الرد. حاول مرة ثانية.",
  "Feedback Widget": "أداة الملاحظات",
  "Files and documents in the system": "الملفات والمستندات في النظام",
  "Focus Score": "درجة التركيز",
  "Folder ID (optional)": "معرّف المجلد (اختياري)",
  "Formal": "رسمي",
  "Found {0} task suggestions": "تم العثور على {0} اقتراحات مهام",
  "French": "الفرنسية",
  "General data protection principles": "المبادئ العامة لحماية البيانات",
  "Generate Digest": "إنشاء الملخص",
  "Generate Meeting Minutes": "إنشاء محضر الاجتماع",
  "Generate report": "إنشاء تقرير",
  "Generated reports and metrics": "التقارير والمؤشرات المُنشأة",
  "Generated within the last 24 hours": "أُنشئ خلال آخر 24 ساعة",
  "Generated {0} synthetic signals": "تم إنشاء {0} إشارات تجريبية",
  "German": "الألمانية",
  "Governance workflows and benefits tracking": "مسارات الحوكمة ومتابعة المنافع",
  "Governance workflows mapped to your governance framework": "مسارات الحوكمة مطابقة لإطار الحوكمة لديك",
  "HITL approval process documented": "إجراء الموافقة البشرية موثّق",
  "Health, milestones and decisions needed": "الصحة والمراحل والقرارات المطلوبة",
  "High / Critical": "عالٍ / حرج",
  "High Power & High Interest - Manage Closely": "قوة عالية واهتمام عالٍ - إدارة عن قرب",
  "High Power & Low Interest - Keep Satisfied": "قوة عالية واهتمام منخفض - الحفاظ على الرضا",
  "High/Critical items": "العناصر العالية/الحرجة",
  "Historical Patterns": "الأنماط التاريخية",
  "Identify, assess and track project risks and mitigations": "حدّد مخاطر المشروع وإجراءات معالجتها وقيّمها وتابعها",
  "If the record still exists in the source system, it will reappear shortly. If it was deleted there too, nothing will come back.": "إذا كان السجل لا يزال موجودًا في النظام المصدر فسيظهر من جديد قريبًا. وإذا حُذف هناك أيضًا فلن يعود شيء.",
  "Imported {0} {1} from {2}": "تم استيراد {0} {1} من {2}",
  "In Review": "قيد المراجعة",
  "In progress": "قيد التنفيذ",
  "In progress / at risk": "قيد التنفيذ / معرّض للخطر",
  "In review": "قيد المراجعة",
  "Inactive": "غير نشط",
  "Including subfolders": "يشمل المجلدات الفرعية",
  "Indian rupee": "روبية هندية",
  "Infrastructure": "البنية التحتية",
  "Inspect delivery data": "فحص بيانات التنفيذ",
  "Instance": "النسخة",
  "Integration": "تكامل",
  "Internal Memo": "مذكرة داخلية",
  "Invited {0} to Masira": "تمت دعوة {0} إلى Masira",
  "Invoice": "فاتورة",
  "Issue created": "تم إنشاء المشكلة",
  "Issue updated": "تم تحديث المشكلة",
  "It will sync on the next scheduled run, or use Sync now.": "سيُزامَن في التشغيل المجدول القادم، أو استخدم «مزامنة الآن».",
  "James Wilson, Program Manager": "James Wilson، مدير برنامج",
  "Japanese yen": "ين ياباني",
  "Jira Domain": "نطاق Jira",
  "KPIs, budget, timeline and team insights": "مؤشرات الأداء والميزانية والجدول الزمني ورؤى الفريق",
  "Keep Informed": "الإبقاء على اطلاع",
  "Keep Satisfied": "الحفاظ على الرضا",
  "Keep a dated record of decisions, owners and rationale": "احتفظ بسجل مؤرَّخ للقرارات ومالكيها ومبرراتها",
  "Key Achievements": "أبرز الإنجازات",
  "Key Players": "اللاعبون الرئيسيون",
  "Kuwaiti dinar": "دينار كويتي",
  "Last quarter": "الربع الماضي",
  "Late Approval": "موافقة متأخرة",
  "Leadership": "القيادة",
  "Limit sync to a specific folder": "حصر المزامنة في مجلد محدد",
  "Link to project": "ربط بمشروع",
  "Live": "مباشر",
  "Live Update": "تحديث مباشر",
  "Load more": "تحميل المزيد",
  "Local (Ollama)": "محلي (Ollama)",
  "Looking for risk/governance actions?": "تدوّر على إجراءات المخاطر/الحوكمة؟",
  "Low Power & High Interest - Keep Informed": "قوة منخفضة واهتمام عالٍ - الإبقاء على اطلاع",
  "Low Power & Low Interest - Monitor": "قوة منخفضة واهتمام منخفض - مراقبة",
  "Mailbox": "صندوق البريد",
  "Major": "كبير",
  "Manual only": "يدوي فقط",
  "Map Outlook categories or subject/body markers to automatically link project correspondence in Smart Inbox.": "اربط فئات Outlook أو علامات الموضوع/النص لربط مراسلات المشاريع تلقائيًا في الصندوق الذكي.",
  "Masira will revoke its access, stop syncing, and permanently delete all files and search chunks ingested from Google Drive. Your Drive files are not changed.": "ستسحب Masira وصولها وتوقف المزامنة وتحذف نهائيًا كل الملفات والمقاطع القابلة للبحث المستوردة من Google Drive. ملفاتك على Drive لا تتغير.",
  "Masira will stop syncing and permanently delete all files and search chunks ingested from OneDrive / SharePoint folders. Microsoft 365 admin consent is not revoked.": "ستوقف Masira المزامنة وتحذف نهائيًا كل الملفات والمقاطع القابلة للبحث المستوردة من مجلدات OneDrive / SharePoint. موافقة مسؤول Microsoft 365 لا تُسحب.",
  "Meeting minutes for Q4 Planning session": "محضر اجتماع جلسة تخطيط الربع الرابع",
  "Meetings ({0}d)": "الاجتماعات ({0} يومًا)",
  "Memo": "مذكرة",
  "Mexican peso": "بيزو مكسيكي",
  "Microsoft 365 (OneDrive / SharePoint)": "Microsoft 365 (OneDrive / SharePoint)",
  "Microsoft 365 Group ID": "معرّف مجموعة Microsoft 365",
  "Milestone / deadline": "مرحلة / موعد نهائي",
  "Milestone and task schedule for tracking the project timeline": "جدول المراحل والمهام لمتابعة الجدول الزمني للمشروع",
  "Minor": "طفيف",
  "Minutes of Meeting (MOM)": "محضر الاجتماع (MOM)",
  "Missing Approval": "موافقة ناقصة",
  "Mitigated this month": "تمت معالجته هذا الشهر",
  "Mobile App Redesign": "إعادة تصميم تطبيق الجوال",
  "Model {0}": "النموذج {0}",
  "Moderate": "معتدل",
  "Modify & Approve Action Item": "تعديل بند الإجراء والموافقة عليه",
  "Modify & Approve Document Candidate": "تعديل المستند المرشح والموافقة عليه",
  "Monitoring": "المراقبة",
  "Monthly Summary": "الملخص الشهري",
  "More Evidence Requested": "مطلوب مزيد من الأدلة",
  "Motion Design": "تصميم الحركة",
  "My Company": "شركتي",
  "My {0}": "{0} الخاصة بي",
  "Name, role, preferences, and settings": "الاسم والدور والتفضيلات والإعدادات",
  "Needs decision": "يحتاج قرارًا",
  "Negligible": "ضئيل",
  "Never synced": "لم تتم المزامنة أبدًا",
  "New Slide": "شريحة جديدة",
  "New risks": "مخاطر جديدة",
  "New this month": "جديد هذا الشهر",
  "Newsletter": "نشرة إخبارية",
  "Next 30 Days": "الـ 30 يومًا القادمة",
  "Next Steps": "الخطوات القادمة",
  "No AI activity recorded yet": "لا يوجد نشاط للذكاء الاصطناعي مسجّل بعد",
  "No HR/Performance Usage": "لا استخدام للموارد البشرية/تقييم الأداء",
  "No active version": "لا توجد نسخة نشطة",
  "No decision events recorded yet.": "لا توجد أحداث قرارات مسجّلة بعد.",
  "No description": "بدون وصف",
  "No expiry": "بدون انتهاء",
  "No files ingested yet.": "لم تُستورد ملفات بعد.",
  "No files match these filters.": "لا توجد ملفات تطابق هذه التصفيات.",
  "No findings": "لا توجد نتائج",
  "No material exceptions.": "لا توجد استثناءات جوهرية.",
  "No new breaches to notify": "لا توجد مخالفات جديدة للإشعار بها",
  "No pending decisions.": "لا توجد قرارات معلّقة.",
  "No status": "بدون حالة",
  "Not connected — required before adding SharePoint, Planner, Outlook, or Teams meetings integrations": "غير مرتبط — مطلوب قبل إضافة تكاملات SharePoint أو Planner أو Outlook أو اجتماعات Teams",
  "Not used yet": "لم يُستخدم بعد",
  "Nothing awaiting review.": "لا شي بانتظار المراجعة.",
  "Nothing is waiting for a decision.": "لا شي بانتظار قرار.",
  "Notification": "إشعار",
  "Object Storage": "تخزين الكائنات",
  "Objectives, scope, stakeholders and governance for a new project": "الأهداف والنطاق وأصحاب المصلحة والحوكمة لمشروع جديد",
  "Off Track": "خارج المسار",
  "Ollama (local, free)": "Ollama (محلي، مجاني)",
  "Omani rial": "ريال عماني",
  "Once a day": "مرة في اليوم",
  "Once a week": "مرة في الأسبوع",
  "OneDrive Documents": "مستندات OneDrive",
  "OneDrive Drive ID": "معرّف OneDrive Drive",
  "Only the author or an admin can edit this template.": "فقط المؤلف أو المسؤول يمكنه تعديل هذا القالب.",
  "Open approvals": "فتح الموافقات",
  "Open decision board": "فتح لوحة القرارات",
  "Open decision log": "فتح سجل القرارات",
  "Open folder {0}": "فتح المجلد {0}",
  "Open portfolio": "فتح المحفظة",
  "Open report": "فتح التقرير",
  "Operational": "تشغيلي",
  "Optional notes": "ملاحظات اختيارية",
  "Organization": "المؤسسة",
  "Organizational decisions and their context": "قرارات المؤسسة وسياقها",
  "Outlook / Email": "Outlook / البريد الإلكتروني",
  "Output updated": "تم تحديث المخرج",
  "Overall portfolio performance": "الأداء العام للمحفظة",
  "Overdue and not done": "متأخر ولم يُنجَز",
  "Overdue, not done": "متأخر، لم يُنجَز",
  "Oversight and accountability for AI use": "الإشراف والمساءلة على استخدام الذكاء الاصطناعي",
  "PMO Control Tower": "برج مراقبة مكتب إدارة المشاريع",
  "Pages visited, features used, interaction patterns": "الصفحات المزارة والميزات المستخدمة وأنماط التفاعل",
  "Pakistani rupee": "روبية باكستانية",
  "Password": "كلمة المرور",
  "Past sprint performance data": "بيانات أداء السبرنتات السابقة",
  "Peak Activity Day": "يوم ذروة النشاط",
  "Peak Productivity": "ذروة الإنتاجية",
  "Pending Review": "بانتظار المراجعة",
  "Performance": "الأداء",
  "Personal Access Token": "رمز الوصول الشخصي",
  "Personal data should be kept no longer than needed for its stated purpose.": "لا ينبغي الاحتفاظ بالبيانات الشخصية أطول مما يلزم لغرضها المعلن.",
  "Personalized": "مخصَّص لك",
  "Personalized for you": "مخصَّص لك",
  "Phase 2 Budget Approval": "الموافقة على ميزانية المرحلة الثانية",
  "Please try again.": "حاول مرة ثانية.",
  "Policy Violation": "مخالفة سياسة",
  "Portfolio KPIs aligned to strategic objectives": "مؤشرات أداء المحفظة متوافقة مع الأهداف الاستراتيجية",
  "Portfolio data is current": "بيانات المحفظة محدّثة",
  "Portfolio health": "صحة المحفظة",
  "Portfolio health, exceptions, decisions and governance status. Operational detail stays one click away.": "صحة المحفظة والاستثناءات والقرارات وحالة الحوكمة. والتفاصيل التشغيلية على بعد ضغطة واحدة.",
  "Portfolio performance": "أداء المحفظة",
  "Pound sterling": "جنيه إسترليني",
  "Power Automate webhook URL": "رابط Webhook لـ Power Automate",
  "Preview {0}": "معاينة {0}",
  "Primary Region": "المنطقة الرئيسية",
  "Processing needs a lawful basis; where consent is the basis it must be informed, specific, and documented in a verifiable form.": "المعالجة تحتاج أساسًا نظاميًا؛ وإذا كانت الموافقة هي الأساس فيجب أن تكون مستنيرة ومحددة وموثّقة بشكل يمكن التحقق منه.",
  "Product": "المنتج",
  "Productivity Score": "درجة الإنتاجية",
  "Productivity, collaboration and recognition": "الإنتاجية والتعاون والتقدير",
  "Program Manager": "مدير برنامج",
  "Progress & Milestones": "التقدم والمراحل",
  "Progress, accomplishments and upcoming tasks": "التقدم والإنجازات والمهام القادمة",
  "Project (optional)": "المشروع (اختياري)",
  "Project Charter": "ميثاق المشروع",
  "Project Data": "بيانات المشروع",
  "Project Health Summary": "ملخص صحة المشروع",
  "Project Kickoff": "انطلاق المشروع",
  "Project Kickoff Meeting": "اجتماع انطلاق المشروع",
  "Project Manager": "مدير مشروع",
  "Project Overview & Goals": "نظرة عامة على المشروع وأهدافه",
  "Project Schedule Plan": "خطة الجدول الزمني للمشروع",
  "Project Signals": "إشارات المشروع",
  "Project Status Report": "تقرير حالة المشروع",
  "Project Update": "تحديث المشروع",
  "Project documents (Google Drive & Microsoft 365)": "مستندات المشاريع (Google Drive وMicrosoft 365)",
  "Project status report template": "قالب تقرير حالة المشروع",
  "Projects aligned to strategic objectives": "المشاريع متوافقة مع الأهداف الاستراتيجية",
  "Projects not updated in 24h": "مشاريع لم تُحدَّث خلال 24 ساعة",
  "Projects you have access to view or manage": "المشاريع التي تملك صلاحية عرضها أو إدارتها",
  "Proposal": "عرض",
  "Prototyping": "النماذج الأولية",
  "Q4 Executive Summary": "الملخص التنفيذي للربع الرابع",
  "Q4 Portfolio Performance Report": "تقرير أداء المحفظة للربع الرابع",
  "Qatari riyal": "ريال قطري",
  "Quarterly Review": "المراجعة الربعية",
  "RACI Matrix": "مصفوفة RACI",
  "ROI Achievement": "تحقيق العائد على الاستثمار",
  "Rate limited or out of quota": "تم تجاوز حد الطلبات أو انتهت الحصة",
  "Real-time overview of your project portfolio": "نظرة فورية على محفظة مشاريعك",
  "Reallocate 2 engineers to strategic PMO project": "إعادة توزيع مهندسَين على مشروع مكتب إدارة المشاريع الاستراتيجي",
  "Reason (required)": "السبب (مطلوب)",
  "Reason for rejecting (required)": "سبب الرفض (مطلوب)",
  "Recent": "الأخيرة",
  "Recent activity": "النشاط الأخير",
  "Recommendation": "التوصية",
  "Recommended: Schedule team sync": "موصى به: جدولة اجتماع للفريق",
  "Record decisions, action items and attendees for any meeting": "سجّل القرارات وبنود الإجراءات والحضور لأي اجتماع",
  "Redirecting…": "جارٍ التحويل…",
  "Reject AI Output": "رفض مخرج الذكاء الاصطناعي",
  "Reject Action Item": "رفض بند الإجراء",
  "Reject Document Candidate": "رفض المستند المرشح",
  "Release health degraded": "تراجع صحة الإصدار",
  "Reminder": "تذكير",
  "Remove all Microsoft folders?": "إزالة كل مجلدات Microsoft؟",
  "Remove all folders": "إزالة كل المجلدات",
  "Remove and delete data": "إزالة وحذف البيانات",
  "Remove folder {0}": "إزالة المجلد {0}",
  "Remove {0}": "إزالة {0}",
  "Removed": "تمت الإزالة",
  "Removed {0} synced records.": "تمت إزالة {0} سجلات متزامنة.",
  "Removing…": "جارٍ الإزالة…",
  "Reply Sent": "تم إرسال الرد",
  "Reply sent, but action update failed": "تم إرسال الرد، لكن فشل تحديث الإجراء",
  "Reply sent, but some actions were not marked complete": "تم إرسال الرد، لكن بعض الإجراءات لم تُعلَّم كمكتملة",
  "Report": "التقرير",
  "Report generated for your portfolio": "تم إنشاء التقرير لمحفظتك",
  "Report status changed to {0}.": "تغيّرت حالة التقرير إلى {0}.",
  "Reports & Analytics": "التقارير والتحليلات",
  "Request a role to access more features": "اطلب دورًا للوصول إلى ميزات أكثر",
  "Resource": "المورد",
  "Resource Conflict": "تعارض موارد",
  "Resource Recommendation": "توصية موارد",
  "Response to vendor inquiry": "رد على استفسار مورّد",
  "Responsible, accountable, consulted and informed roles across tasks": "أدوار المسؤول والمحاسَب والمستشار والمُطَّلع عبر المهام",
  "Resume AI Outputs": "استئناف مخرجات الذكاء الاصطناعي",
  "Retry Sync": "إعادة محاولة المزامنة",
  "Return on investment": "العائد على الاستثمار",
  "Revenue generated": "الإيرادات المحققة",
  "Review marketing proposal": "مراجعة العرض التسويقي",
  "Review risks": "مراجعة المخاطر",
  "Review saved, but ingestion failed: {0}": "تم حفظ المراجعة، لكن فشل الاستيراد: {0}",
  "Risk Alert: Budget Overrun Predicted": "تنبيه خطر: توقّع تجاوز الميزانية",
  "Risk Assessment": "تقييم المخاطر",
  "Risk Assessment Summary": "ملخص تقييم المخاطر",
  "Risk Indicators": "مؤشرات المخاطر",
  "Risk Prediction": "توقّع المخاطر",
  "Risk Register": "سجل المخاطر",
  "Risk Report": "تقرير المخاطر",
  "Risk Review": "مراجعة المخاطر",
  "Risk Surfaced": "تم رصد خطر",
  "Risk dashboard, mitigation status and actions": "لوحة المخاطر وحالة المعالجة والإجراءات",
  "Roadmapping": "تخطيط خارطة الطريق",
  "Role Access": "وصول الأدوار",
  "Role updated to {0}": "تم تحديث الدور إلى {0}",
  "Role-based access": "وصول حسب الدور",
  "Rolled back to v{0}": "تم التراجع إلى النسخة {0}",
  "SLA Breach": "مخالفة اتفاقية مستوى الخدمة",
  "SSO / Login URL": "رابط SSO / تسجيل الدخول",
  "SSO provider activation requires configuration in your Supabase Auth dashboard. These settings persist your IdP metadata for reference. Contact your platform administrator to complete server-side SAML/OIDC setup.": "تفعيل مزود SSO يتطلب إعدادًا في لوحة Supabase Auth. هذه الإعدادات تحفظ بيانات مزود الهوية للمرجع. تواصل مع مسؤول المنصة لإكمال إعداد SAML/OIDC من جهة الخادم.",
  "Sarah Mitchell, PMO Director": "Sarah Mitchell، مديرة مكتب إدارة المشاريع",
  "Saudi riyal": "ريال سعودي",
  "Save Template": "حفظ القالب",
  "Save template": "حفظ القالب",
  "Saved v{0}": "تم حفظ النسخة {0}",
  "Scanned synced data for signals": "تم فحص البيانات المتزامنة بحثًا عن إشارات",
  "Schedule slip detected on Project Metro Expansion": "تم رصد تأخر في الجدول الزمني لمشروع توسعة المترو",
  "Scheduled": "مجدول",
  "Scheduled meetings and calendar events": "الاجتماعات المجدولة وأحداث التقويم",
  "Scope": "النطاق",
  "Score": "الدرجة",
  "Security Compliance Update": "تحديث الامتثال الأمني",
  "See Power Automate template in Settings → Resources": "انظر قالب Power Automate في الإعدادات ← الموارد",
  "See exceptions first. Drill into a project only when needed.": "شاهد الاستثناءات أولًا. وادخل في تفاصيل المشروع عند الحاجة فقط.",
  "Self-hosted vLLM": "vLLM مستضاف ذاتيًا",
  "Senior Project Manager": "مدير مشروع أول",
  "Sent {0} alert(s)": "تم إرسال {0} تنبيه(ات)",
  "Sentiment analysis on 12 emails": "تحليل المشاعر لـ 12 رسالة",
  "SharePoint Site ID": "معرّف موقع SharePoint",
  "Shared with everyone in your organisation. Markdown or plain text.": "مشترك مع كل من في مؤسستك. بصيغة Markdown أو نص عادي.",
  "Signal accepted": "تم قبول الإشارة",
  "Signal rejected": "تم رفض الإشارة",
  "Since {0} — required for SharePoint, Planner, Outlook & Teams meetings": "منذ {0} — مطلوب لـ SharePoint وPlanner وOutlook واجتماعات Teams",
  "Singapore dollar": "دولار سنغافوري",
  "Smart Inbox": "الصندوق الذكي",
  "Smart Inbox / Communication Signals": "الصندوق الذكي / إشارات التواصل",
  "Some portfolio data is stale": "بعض بيانات المحفظة قديمة",
  "South African rand": "راند جنوب أفريقي",
  "Spanish": "الإسبانية",
  "Special categories of personal data (e.g. health, biometric, beliefs) call for stricter controls than ordinary personal data.": "الفئات الخاصة من البيانات الشخصية (مثل الصحية والحيوية والمعتقدات) تستدعي ضوابط أشد من البيانات الشخصية العادية.",
  "Specific project name": "اسم مشروع محدد",
  "Stakeholder Mgmt": "إدارة أصحاب المصلحة",
  "Stakeholder Review": "مراجعة أصحاب المصلحة",
  "Stakeholder Update": "تحديث أصحاب المصلحة",
  "Stakeholder sync with Product team": "اجتماع أصحاب المصلحة مع فريق المنتج",
  "Status Report": "تقرير الحالة",
  "Status Slip": "تراجع الحالة",
  "Status Update": "تحديث الحالة",
  "Strategic": "استراتيجي",
  "Strategic Alignment": "المواءمة الاستراتيجية",
  "Strategic Initiative Update": "تحديث المبادرة الاستراتيجية",
  "Strategic Update": "تحديث استراتيجي",
  "Strategy View": "عرض الاستراتيجية",
  "Success Criteria": "معايير النجاح",
  "Successfully synced {0} meetings from Microsoft Teams": "تمت مزامنة {0} اجتماعات من Microsoft Teams بنجاح",
  "Suggest Tasks": "اقتراح مهام",
  "Suggested": "مقترح",
  "Swiss franc": "فرنك سويسري",
  "Sync All": "مزامنة الكل",
  "Sync Now": "مزامنة الآن",
  "Sync frequency for {0}": "تكرار المزامنة لـ {0}",
  "Sync frequency updated to {0}": "تم تحديث تكرار المزامنة إلى {0}",
  "Sync is healthy": "المزامنة سليمة",
  "Sync is stale": "المزامنة قديمة",
  "Sync now": "مزامنة الآن",
  "Sync {0} now": "مزامنة {0} الآن",
  "Synced {0}": "تمت المزامنة {0}",
  "Synced {0} records": "تمت مزامنة {0} سجلات",
  "Syncing...": "جارٍ المزامنة...",
  "Syncing…": "جارٍ المزامنة…",
  "System Design": "تصميم النظام",
  "Task \"{0}\" added to Action Hub": "تمت إضافة المهمة \"{0}\" إلى مركز الإجراءات",
  "Task Board": "لوحة المهام",
  "Task Reminder": "تذكير بمهمة",
  "Tasks & Assignments": "المهام والتكليفات",
  "Tasks assigned to you and your team": "المهام المسندة لك ولفريقك",
  "Team & Roles": "الفريق والأدوار",
  "Team productivity metrics, AI efficiency gains, and collaboration insights": "مؤشرات إنتاجية الفريق ومكاسب كفاءة الذكاء الاصطناعي ورؤى التعاون",
  "Team visibility": "ظهور الفريق",
  "Teams sync failed: {0}": "فشلت مزامنة Teams: {0}",
  "Template created": "تم إنشاء القالب",
  "Template saved": "تم حفظ القالب",
  "Template updated": "تم تحديث القالب",
  "Tenant language, text direction and currency": "لغة المؤسسة واتجاه النص والعملة",
  "Test Automation": "أتمتة الاختبار",
  "Test failed": "فشل الاختبار",
  "The drive to sync documents from": "الـ Drive المراد مزامنة المستندات منه",
  "The first sync has started.": "بدأت أول مزامنة.",
  "The group that owns the Planner plan(s)": "المجموعة المالكة لخطة(خطط) Planner",
  "Things that can change the plan.": "أمور ممكن تغيّر الخطة.",
  "This content has been reviewed and approved by a human": "تمت مراجعة هذا المحتوى واعتماده من شخص",
  "This content has been reviewed by a human": "تمت مراجعة هذا المحتوى من شخص",
  "This content was generated by AI and may need review": "هذا المحتوى أُنشئ بالذكاء الاصطناعي وقد يحتاج مراجعة",
  "This folder only": "هذا المجلد فقط",
  "This project has risks that need to be monitored": "في هذا المشروع مخاطر تحتاج مراقبة",
  "This project requires immediate attention due to critical issues": "يحتاج هذا المشروع اهتمامًا فوريًا بسبب مشكلات حرجة",
  "Time Saved This Week": "الوقت الموفَّر هذا الأسبوع",
  "Time Saved by AI": "الوقت الموفَّر بالذكاء الاصطناعي",
  "Timeline & Milestones": "الجدول الزمني والمراحل",
  "Timeline · last {0} days": "الجدول الزمني · آخر {0} يومًا",
  "Toggle {0} access": "تبديل وصول {0}",
  "Transcript upload failed: {0}": "فشل رفع النص المفرّغ: {0}",
  "Transfers outside the originating jurisdiction need an approved mechanism (e.g. Standard Contractual Clauses) or equivalent safeguards.": "النقل خارج الولاية القضائية الأصلية يحتاج آلية معتمدة (مثل البنود التعاقدية القياسية) أو ضمانات مكافئة.",
  "Triggered sync for {0} integration{1}": "تم تشغيل المزامنة لـ {0} تكامل",
  "Trust status unknown": "حالة الثقة غير معروفة",
  "Try adjusting your search": "جرّب تعديل البحث",
  "Try again": "حاول مرة ثانية",
  "Try again.": "حاول مرة ثانية.",
  "Turkish lira": "ليرة تركية",
  "UAE dirham": "درهم إماراتي",
  "UI Design": "تصميم الواجهات",
  "US dollar": "دولار أمريكي",
  "Under budget is positive": "الأقل من الميزانية إيجابي",
  "Unexpected response": "رد غير متوقع",
  "Unfiled": "غير مصنّف",
  "Unknown": "غير معروف",
  "Unknown Integration": "تكامل غير معروف",
  "Unknown error": "خطأ غير معروف",
  "Unknown user": "مستخدم غير معروف",
  "Unlinked": "غير مرتبط",
  "Unnamed User": "مستخدم بلا اسم",
  "Unresolved": "غير محلول",
  "Unsupported": "غير مدعوم",
  "Untitled": "بدون عنوان",
  "Untitled Slide": "شريحة بدون عنوان",
  "Up to {0} files are analyzed per click.": "يُحلَّل حتى {0} ملفات في كل ضغطة.",
  "Update connection settings": "تحديث إعدادات الاتصال",
  "Update your document template": "حدّث قالب مستندك",
  "Used {0}×{1}": "استُخدم {0}×{1}",
  "User Research": "أبحاث المستخدمين",
  "Username": "اسم المستخدم",
  "Vendor Pressure": "ضغط المورّد",
  "Vendor Selection - Cloud Platform": "اختيار المورّد - المنصة السحابية",
  "Very High": "مرتفع جدًا",
  "Very Low": "منخفض جدًا",
  "Visible to Program Managers and above": "ظاهر لمديري البرامج ومن فوقهم",
  "Waiting for action": "بانتظار إجراء",
  "Webhook URL": "رابط Webhook",
  "Weekly Newsletter": "النشرة الأسبوعية",
  "Weekly Status Report": "تقرير الحالة الأسبوعي",
  "Weekly Status Update": "تحديث الحالة الأسبوعي",
  "Weekly or monthly status report with progress, risks and next steps": "تقرير حالة أسبوعي أو شهري يتضمن التقدم والمخاطر والخطوات القادمة",
  "Welcome": "مرحبًا",
  "Welcome Email": "بريد الترحيب",
  "What evidence is needed (required)": "ما الدليل المطلوب (مطلوب)",
  "What needs PMO attention?": "وش اللي يحتاج اهتمام مكتب إدارة المشاريع؟",
  "What tone fits?": "أي نبرة تناسب؟",
  "Which period should it cover?": "أي فترة يغطيها؟",
  "Who is it for?": "لمن هو؟",
  "Who needs what information, how often, and through which channel": "من يحتاج أي معلومة، وكم مرة، وعبر أي قناة",
  "Working…": "جارٍ العمل…",
  "Workload Analysis": "تحليل عبء العمل",
  "Yes": "نعم",
  "You created this": "أنت أنشأت هذا",
  "You may not have permission to update one or more checked actions.": "قد لا تملك صلاحية تحديث واحد أو أكثر من الإجراءات المحددة.",
  "Your Activity": "نشاطك",
  "Your Jira API token": "رمز Jira API الخاص بك",
  "Your PAT": "رمز الوصول الشخصي الخاص بك",
  "Your Profile": "ملفك الشخصي",
  "Your Team": "فريقك",
  "Your most productive hours are 9 AM - 12 PM. AI suggests scheduling complex tasks during this window.": "أكثر ساعاتك إنتاجية من 9 ص إلى 12 م. يقترح الذكاء الاصطناعي جدولة المهام المعقدة في هذه الفترة.",
  "Your password": "كلمة مرورك",
  "Your tagline here": "عبارتك التعريفية هنا",
  "accepted": "مقبول",
  "acknowledged": "تم الإقرار",
  "amber": "كهرماني",
  "approvals ·": "موافقات ·",
  "approved": "معتمد",
  "archived": "مؤرشف",
  "cancelled": "ملغى",
  "closed": "مغلق",
  "completed": "مكتمل",
  "confirmed": "مؤكَّد",
  "corrected": "مصحَّح",
  "data (projects/tasks pulled in by any sync).": "بيانات (مشاريع/مهام سحبتها أي مزامنة).",
  "decisions": "قرارات",
  "dismissed": "تم التجاهل",
  "draft": "مسودة",
  "due": "مستحق",
  "green": "أخضر",
  "healthy": "سليم",
  "in-progress": "قيد التنفيذ",
  "inactive": "غير نشط",
  "mitigated": "تمت المعالجة",
  "more evidence requested": "مطلوب مزيد من الأدلة",
  "none": "لا شي",
  "normal": "عادي",
  "open": "مفتوح",
  "overdue, was due": "متأخر، كان مستحقًا",
  "pending review": "بانتظار المراجعة",
  "pending_review": "بانتظار المراجعة",
  "planned": "مخطط",
  "published": "منشور",
  "queued": "في الطابور",
  "red": "أحمر",
  "rejected": "مرفوض",
  "resolved": "محلول",
  "reviewed": "تمت المراجعة",
  "running": "قيد التشغيل",
  "scheduled": "مجدول",
  "success": "ناجح",
  "suggested": "مقترح",
  "to do": "للتنفيذ",
  "todo": "للتنفيذ",
  "unknown": "غير معروف",
  "urgent": "عاجل",
  "{0} / {1} is now active.": "{0} / {1} نشط الآن.",
  "{0} CIDR range(s) active.": "{0} نطاق(ات) CIDR نشطة.",
  "{0} Issues": "{0} مشكلات",
  "{0} at risk, {1} critical": "{0} معرّضة للخطر، {1} حرجة",
  "{0} budget used": "{0} من الميزانية مستخدم",
  "{0} current breach(es) checked.": "تم فحص {0} مخالفة(ات) حالية.",
  "{0} details for {1}": "تفاصيل {0} لـ {1}",
  "{0} document(s) analyzed, {1} failed — they'll be retried on the next sync.": "تم تحليل {0} مستند(ات)، وفشل {1} — ستُعاد محاولتها في المزامنة القادمة.",
  "{0} document(s) analyzed.": "تم تحليل {0} مستند(ات).",
  "{0} event{1} recorded in the last 7 days. Each links back to the decision, so you can trace evidence to decision to action.": "{0} أحداث مسجّلة في آخر 7 أيام. كل حدث يرتبط بقراره، لتتبّع الدليل ثم القرار ثم الإجراء.",
  "{0} has been added to your templates.": "تمت إضافة {0} إلى قوالبك.",
  "{0} has been added.": "تمت إضافة {0}.",
  "{0} has been generated successfully.": "تم إنشاء {0} بنجاح.",
  "{0} has been {1}.": "{0} تم {1}.",
  "{0} ingested files": "{0} ملفات مستوردة",
  "{0} is in the Documents tab.": "{0} موجود في تبويب المستندات.",
  "{0} is ready to review and export.": "{0} جاهز للمراجعة والتصدير.",
  "{0} item{1} need attention. Every AI output stays a draft until a person approves it.": "{0} عناصر تحتاج اهتمامًا. كل مخرج ذكاء اصطناعي يبقى مسودة حتى يوافق عليه شخص.",
  "{0} on track": "{0} على المسار",
  "{0} progress": "تقدم {0}",
  "{0} projects · {1} tasks · {2} KPIs · {3} synced records": "{0} مشاريع · {1} مهام · {2} مؤشرات أداء · {3} سجلات متزامنة",
  "{0} schedule elapsed": "{0} من الجدول الزمني انقضى",
  "{0} signal{1}": "{0} إشارات",
  "{0} spent": "{0} مصروف",
  "{0} waiting, {1} not loaded yet. Load more files to include them. Up to {2} are analyzed per click.": "{0} بانتظار التحليل، و{1} لم تُحمَّل بعد. حمّل المزيد من الملفات لتشملها. يُحلَّل حتى {2} في كل ضغطة.",
  "{0}, {1} risk. Open project.": "{0}، خطر {1}. افتح المشروع.",
  "{0}/{1} connection(s) synced — check the Integrations page for details.": "تمت مزامنة {0}/{1} اتصال(ات) — راجع صفحة التكاملات للتفاصيل.",
  "{0}: {1} open, worst {2}": "{0}: {1} مفتوحة، الأسوأ {2}",
  "release health degraded": "تراجع صحة الإصدار",
  "blocked dependency": "اعتمادية متعطلة",
  "overdue not done": "متأخر ولم يُنجَز",
  "Project risk": "خطر على المشروع",
  "Execution risk": "خطر في التنفيذ",
  "PMO": "مكتب إدارة المشاريع",
  "Admin": "مسؤول",
  "User": "مستخدم",
  "Portfolio risk": "خطر على المحفظة",
  "Governance risk": "خطر في الحوكمة",
  // ---- PMO Control Tower ----
  "{0} of {1} spent": "{0} مصروف من {1}",
  "{0} over budget": "{0} تجاوزت الميزانية",
  "Waiting on PMO": "بانتظار مكتب إدارة المشاريع",
  "{0} approvals · {1} decisions": "{0} موافقات · {1} قرارات",
  "Policy breaches": "مخالفات السياسات",
  "Everything is within policy": "كل شي ضمن السياسة",
  "AI outputs past their review deadline": "مخرجات ذكاء اصطناعي تجاوزت موعد مراجعتها",
  "Worst first. Open a project to see its risks.": "الأسوأ أولًا. افتح مشروعًا لعرض مخاطره.",
  "Projects could not be loaded.": "تعذّر تحميل المشاريع.",
  "{0}: {1}. Open its risks.": "{0}: {1}. افتح مخاطره.",
  "Overdue decisions first, then the oldest items.": "القرارات المتأخرة أولًا، ثم الأقدم.",
  "due {0}": "الاستحقاق {0}",
  "Not recorded": "غير مسجّل",
  // ---- Executive Brief and Project Cockpit ----
  "AI output a person has reviewed and approved. Nothing unreviewed appears here.": "مخرجات ذكاء اصطناعي راجعها شخص واعتمدها. لا يظهر هنا أي شي غير مُراجَع.",
  "Approved summaries": "الملخصات المعتمدة",
  "Approved summaries could not be loaded.": "تعذّر تحميل الملخصات المعتمدة.",
  "Assigned to me": "المسندة لي",
  "Decisions waiting": "قرارات بانتظارك",
  "Decisions waiting on you": "قرارات بانتظارك",
  "Every project is on track.": "كل المشاريع على المسار.",
  "Executive Brief": "الموجز التنفيذي",
  "No approved summaries yet.": "لا توجد ملخصات معتمدة بعد.",
  "No due date": "بدون تاريخ استحقاق",
  "No open tasks are assigned to {0}.": "لا توجد مهام مفتوحة مسندة إلى {0}.",
  "No unread messages.": "لا توجد رسائل غير مقروءة.",
  "Nothing is overdue.": "ما فيه شي متأخر.",
  "Oldest first.": "الأقدم أولًا.",
  "Only projects that are at risk or critical.": "فقط المشاريع المعرّضة للخطر أو الحرجة.",
  "Open projects": "فتح المشاريع",
  "Open strategy": "فتح الاستراتيجية",
  "Overdue first, then the nearest due date.": "المتأخر أولًا، ثم الأقرب استحقاقًا.",
  "Overdue tasks": "المهام المتأخرة",
  "Overdue work": "الأعمال المتأخرة",
  "Project Cockpit": "قمرة قيادة المشاريع",
  "Projects needing attention": "مشاريع تحتاج اهتمامًا",
  "Replies owed": "ردود مطلوبة",
  "Set a display name in Settings so tasks can be matched to you.": "حدّد اسمًا معروضًا في الإعدادات حتى تُربط المهام بك.",
  "Tasks could not be loaded.": "تعذّر تحميل المهام.",
  "Tasks whose assignee is {0}.": "المهام المسندة إلى {0}.",
  "Unblock these first; everything behind them is waiting.": "فكّ تعطّل هذه أولًا؛ كل ما وراءها ينتظر.",
  "Unread, escalations first.": "غير المقروء، والتصعيدات أولًا.",
  "What is blocking my projects?": "وش اللي معطّل مشاريعي؟",
  "What needs my decision?": "وش اللي يحتاج قراري؟",
  "Work is stalled until these are unblocked.": "العمل متوقف حتى يُفك تعطّل هذه.",
  "approved {0}": "اعتُمد {0}",
  "oldest was due {0}": "أقدمها كان مستحقًا {0}",
  "overdue since {0}": "متأخر منذ {0}",
  "{0} at stake": "{0} على المحك",
  "{0} escalated among the latest": "{0} مُصعَّدة ضمن الأحدث",
  "{0} of {1} pillars on target": "{0} من {1} ركائز على الهدف",
  "{0} overdue": "{0} متأخرة",
  "with open tasks; health is not visible to your role": "فيها مهام مفتوحة؛ الصحة غير ظاهرة لدورك",
  "Project details are not visible to your role. Ask an administrator if you need them.": "تفاصيل المشاريع غير ظاهرة لدورك. اطلبها من المسؤول إذا احتجتها.",
  // ---- My Day, Program Board, Workspace Health ----
  "A source needs attention when it is active but has not synced in 48 hours.": "المصدر يحتاج اهتمامًا إذا كان نشطًا ولم يتزامن خلال 48 ساعة.",
  "AI outputs": "مخرجات الذكاء الاصطناعي",
  "AI outputs are flowing through human review.": "مخرجات الذكاء الاصطناعي تمر عبر المراجعة البشرية.",
  "AI safety": "أمان الذكاء الاصطناعي",
  "Action items could not be loaded.": "تعذّر تحميل بنود الإجراءات.",
  "Actions to review": "إجراءات للمراجعة",
  "Assigned to you by account or by the name {0}.": "مسندة لك بحسابك أو بالاسم {0}.",
  "Assigned to your account.": "مسندة لحسابك.",
  "Blocked dependencies": "اعتماديات متعطلة",
  "Data sources could not be loaded.": "تعذّر تحميل مصادر البيانات.",
  "Due this week": "مستحق هذا الأسبوع",
  "Failed syncs (24h)": "مزامنات فاشلة (24 ساعة)",
  "Halted": "متوقف",
  "Highest severity first.": "الأعلى خطورة أولًا.",
  "Is the workspace healthy?": "هل مساحة العمل سليمة؟",
  "Kill switch status could not be read.": "تعذّرت قراءة حالة مفتاح الإيقاف الطارئ.",
  "Meetings could not be loaded.": "تعذّر تحميل الاجتماعات.",
  "My Day": "يومي",
  "My action items": "بنود إجراءاتي",
  "Newest first.": "الأحدث أولًا.",
  "No action items are waiting for review.": "لا توجد بنود إجراءات بانتظار المراجعة.",
  "No meetings are visible to your role yet.": "لا توجد اجتماعات ظاهرة لدورك بعد.",
  "No role requests are waiting.": "لا توجد طلبات أدوار بالانتظار.",
  "No sync failed in the last 24 hours.": "لم تفشل أي مزامنة خلال آخر 24 ساعة.",
  "Nothing is assigned to you.": "ما فيه شي مسند لك.",
  "Nothing is waiting on a dependency.": "ما فيه شي ينتظر اعتمادية.",
  "Open dependencies": "فتح الاعتماديات",
  "Open meetings": "فتح الاجتماعات",
  "Open reports": "فتح التقارير",
  "Overdue": "متأخر",
  "People waiting for access.": "أشخاص بانتظار الوصول.",
  "Program Board": "لوحة البرامج",
  "Risks could not be loaded.": "تعذّر تحميل المخاطر.",
  "Role request: {0}": "طلب الدور: {0}",
  "Role requests": "طلبات الأدوار",
  "Role requests could not be loaded.": "تعذّر تحميل طلبات الأدوار.",
  "Suggested by AI from meetings and email. Nothing is tracked until a person approves it.": "مقترحة من الذكاء الاصطناعي من الاجتماعات والبريد. لا يُتابَع شي حتى يوافق عليه شخص.",
  "Sync history could not be loaded.": "تعذّر تحميل سجل المزامنة.",
  "Tasks that cannot move until another task does.": "مهام ما تتحرك حتى تتحرك مهمة ثانية.",
  "The AI kill switch is active.": "مفتاح الإيقاف الطارئ للذكاء الاصطناعي مفعّل.",
  "Top risks": "أهم المخاطر",
  "Users": "المستخدمون",
  "What do I need to do today?": "وش اللي لازم أسويه اليوم؟",
  "Where are my programmes at risk?": "وين برامجي معرّضة للخطر؟",
  "Workspace Health": "صحة مساحة العمل",
  "Worst first, with open risks. Open a project to see its risks.": "الأسوأ أولًا، مع المخاطر المفتوحة. افتح مشروعًا لعرض مخاطره.",
  "Your role": "دورك",
  "extracted from meetings and email": "مستخرجة من الاجتماعات والبريد",
  "in the next 7 days": "خلال الأيام السبعة القادمة",
  "open and assigned to you": "مفتوحة ومسندة لك",
  "past their due date": "تجاوزت تاريخ استحقاقها",
  "requested {0}": "طُلب {0}",
  "see the list below": "انظر القائمة أدناه",
  "work waiting on other work": "عمل ينتظر عملًا آخر",
  "{0} high or critical": "{0} عالية أو حرجة",
  "{0} need attention, {1} paused": "{0} تحتاج اهتمامًا، {1} متوقفة",
  "{0} open risks": "{0} مخاطر مفتوحة",
  "{0} past their review deadline": "{0} تجاوزت موعد مراجعتها",
  "{0} role requests waiting": "{0} طلبات أدوار بالانتظار",
  "{0} open risk": "{0} خطر مفتوح",
};
